
var Rive = (() => {
  var _scriptName = typeof document != 'undefined' ? document.currentScript?.src : undefined;
  
  return (
function(moduleArg = {}) {
  var moduleRtn;

var l = moduleArg, aa, ba, ca = new Promise((a, b) => {
  aa = a;
  ba = b;
}), da = "object" == typeof window, ea = "function" == typeof importScripts;
function fa() {
  function a(g) {
    const k = d;
    c = b = 0;
    d = new Map();
    k.forEach(m => {
      try {
        m(g);
      } catch (p) {
        console.error(p);
      }
    });
    this.jb();
    e && e.Ib();
  }
  let b = 0, c = 0, d = new Map(), e = null, f = null;
  this.requestAnimationFrame = function(g) {
    b ||= requestAnimationFrame(a.bind(this));
    const k = ++c;
    d.set(k, g);
    return k;
  };
  this.cancelAnimationFrame = function(g) {
    d.delete(g);
    b && 0 == d.size && (cancelAnimationFrame(b), b = 0);
  };
  this.Gb = function(g) {
    f && (document.body.remove(f), f = null);
    g || (f = document.createElement("div"), f.style.backgroundColor = "black", f.style.position = "fixed", f.style.right = 0, f.style.top = 0, f.style.color = "white", f.style.padding = "4px", f.innerHTML = "RIVE FPS", g = function(k) {
      f.innerHTML = "RIVE FPS " + k.toFixed(1);
    }, document.body.appendChild(f));
    e = new function() {
      let k = 0, m = 0;
      this.Ib = function() {
        var p = performance.now();
        m ? (++k, p -= m, 1000 < p && (g(1000 * k / p), k = m = 0)) : (m = p, k = 0);
      };
    }();
  };
  this.jb = function() {
  };
}
function ia() {
  console.assert(!0);
  const a = new Map();
  let b = -Infinity;
  this.push = function(c) {
    c = c + 255 >> 8;
    a.has(c) && clearTimeout(a.get(c));
    a.set(c, setTimeout(function() {
      a.delete(c);
      0 == a.length ? b = -Infinity : c == b && (b = Math.max(...a.keys()), console.assert(b < c));
    }, 1000));
    b = Math.max(c, b);
    return b << 8;
  };
}
const ja = l.onRuntimeInitialized;
l.onRuntimeInitialized = function() {
  ja && ja();
  let a = l.decodeAudio;
  l.decodeAudio = function(e, f) {
    e = a(e);
    f(e);
  };
  let b = l.decodeFont;
  l.decodeFont = function(e, f) {
    e = b(e);
    f(e);
  };
  const c = l.FileAssetLoader;
  l.ptrToAsset = e => {
    let f = l.ptrToFileAsset(e);
    return f.isImage ? l.ptrToImageAsset(e) : f.isFont ? l.ptrToFontAsset(e) : f.isAudio ? l.ptrToAudioAsset(e) : f;
  };
  l.CustomFileAssetLoader = c.extend("CustomFileAssetLoader", {__construct:function({loadContents:e}) {
    this.__parent.__construct.call(this);
    this.yb = e;
  }, loadContents:function(e, f) {
    e = l.ptrToAsset(e);
    return this.yb(e, f);
  },});
  l.CDNFileAssetLoader = c.extend("CDNFileAssetLoader", {__construct:function() {
    this.__parent.__construct.call(this);
  }, loadContents:function(e) {
    let f = l.ptrToAsset(e);
    e = f.cdnUuid;
    if ("" === e) {
      return !1;
    }
    (function(g, k) {
      var m = new XMLHttpRequest();
      m.responseType = "arraybuffer";
      m.onreadystatechange = function() {
        4 == m.readyState && 200 == m.status && k(m);
      };
      m.open("GET", g, !0);
      m.send(null);
    })(f.cdnBaseUrl + "/" + e, g => {
      f.decode(new Uint8Array(g.response));
    });
    return !0;
  },});
  l.FallbackFileAssetLoader = c.extend("FallbackFileAssetLoader", {__construct:function() {
    this.__parent.__construct.call(this);
    this.eb = [];
  }, addLoader:function(e) {
    this.eb.push(e);
  }, loadContents:function(e, f) {
    for (let g of this.eb) {
      if (g.loadContents(e, f)) {
        return !0;
      }
    }
    return !1;
  },});
  let d = l.computeAlignment;
  l.computeAlignment = function(e, f, g, k, m = 1.0) {
    return d.call(this, e, f, g, k, m);
  };
};
const ka = l.onRuntimeInitialized;
l.onRuntimeInitialized = function() {
  function a(t) {
    this.G = t;
    this.vb = t.getContext("2d");
    this.Ab = e;
    this.R = [];
    this.ia = 0;
    this.clear = function() {
      console.assert(0 == this.ia);
      this.R = [];
      f.delete(this);
    };
    this.save = function() {
      ++this.ia;
      this.R.push(e.save.bind(e));
    };
    this.restore = function() {
      0 < this.ia && (this.R.push(e.restore.bind(e)), --this.ia);
    };
    this.transform = function(u) {
      this.R.push(e.transform.bind(e, u));
    };
    this.align = function(u, z, C, E, M = 1.0) {
      this.R.push(e.align.bind(e, u, z, C, E, M));
    };
    this.flush = function() {
      console.assert(0 == this.ia);
      f.add(this);
      d && c();
    };
  }
  function b(t) {
    var u = {alpha:1, depth:0, stencil:8, antialias:0, premultipliedAlpha:1, preserveDrawingBuffer:0, powerPreference:"high-performance", failIfMajorPerformanceCaveat:0, enableExtensionsByDefault:1, explicitSwapControl:0, renderViaOffscreenBackBuffer:0,}, z = t.getContext("webgl2", u);
    z ||= t.getContext("webgl", u);
    var C = z, E = la(ma), M = {handle:E, attributes:u, version:u.zc, Sa:C};
    C.canvas && (C.canvas.ic = M);
    ma[E] = M;
    ("undefined" == typeof u.Fb || u.Fb) && na(M);
    oa(E);
    u = g(t.width, t.height);
    u.xb = E;
    u.G = t;
    u.Ua = t.width;
    u.Ta = t.height;
    u.wb = z;
    return u;
  }
  function c() {
    if (e) {
      var t = e.zb, u = 0, z = 0, C = 0, E = Array(f.size), M = 0;
      for (var N of f) {
        N.ca = Math.min(N.G.width, t), N.ba = Math.min(N.G.height, t), N.Ha = N.ba * N.ca, u = Math.max(u, N.ca), z = Math.max(z, N.ba), C += N.Ha, E[M++] = N;
      }
      f.clear();
      if (!(0 >= C)) {
        u = 1 << (0 >= u ? 0 : 32 - Math.clz32(u - 1));
        for (z = 1 << (0 >= z ? 0 : 32 - Math.clz32(z - 1)); z * u < C;) {
          u <= z ? u *= 2 : z *= 2;
        }
        u = Math.min(u, t);
        u = Math.min(z, t);
        E.sort((ha, yb) => yb.Ha - ha.Ha);
        C = new l.DynamicRectanizer(t);
        for (N = 0; N < E.length;) {
          C.reset(u, z);
          for (M = N; M < E.length; ++M) {
            var O = E[M], L = C.addRect(O.ca, O.ba);
            if (0 > L) {
              console.assert(M > N);
              break;
            }
            O.oa = L & 65535;
            O.pa = L >> 16;
          }
          O = m.push(C.drawWidth());
          L = p.push(C.drawHeight());
          console.assert(O >= C.drawWidth());
          console.assert(L >= C.drawHeight());
          console.assert(O <= t);
          console.assert(L <= t);
          e.G.width != O && (e.G.width = O);
          e.G.height != L && (e.G.height = L);
          e.clear();
          for (O = N; O < M; ++O) {
            L = E[O];
            e.saveClipRect(L.oa, L.pa, L.oa + L.ca, L.pa + L.ba);
            let ha = new l.Mat2D();
            ha.xx = L.ca / L.G.width;
            ha.yy = L.ba / L.G.height;
            ha.xy = ha.yx = 0;
            ha.tx = L.oa;
            ha.ty = L.pa;
            e.transform(ha);
            for (const yb of L.R) {
              yb();
            }
            e.restoreClipRect();
            L.R = [];
          }
          for (e.flush(); N < M; ++N) {
            O = E[N], L = O.vb, L.globalCompositeOperation = "copy", L.drawImage(e.G, O.oa, O.pa, O.ca, O.ba, 0, 0, O.G.width, O.G.height);
          }
          N = M;
        }
      }
    }
  }
  ka && ka();
  const d = navigator.userAgent.match(/firefox|fxios/i);
  let e = null;
  const f = new Set(), g = l.makeRenderer;
  l.makeRenderer = function(t, u) {
    return u ? (e || (e = b(document.createElement("canvas")), u = e.wb, e.zb = Math.min(u.getParameter(u.MAX_RENDERBUFFER_SIZE), u.getParameter(u.MAX_TEXTURE_SIZE))), new a(t)) : b(t);
  };
  const k = l.Artboard.prototype.draw;
  l.Artboard.prototype.draw = function(t) {
    t.R ? t.R.push(k.bind(this, t.Ab)) : k.call(this, t);
  };
  const m = new ia(), p = new ia(), r = new fa();
  l.requestAnimationFrame = r.requestAnimationFrame.bind(r);
  l.cancelAnimationFrame = r.cancelAnimationFrame.bind(r);
  l.enableFPSCounter = r.Gb.bind(r);
  r.jb = c;
  l.resolveAnimationFrame = c;
  let w = l.load;
  l.load = function(t, u, z = !0) {
    const C = new l.FallbackFileAssetLoader();
    void 0 !== u && C.addLoader(u);
    z && (u = new l.CDNFileAssetLoader(), C.addLoader(u));
    return Promise.resolve(w(t, C));
  };
  const y = l.WebGLRenderer.prototype.clear;
  l.WebGLRenderer.prototype.clear = function() {
    oa(this.xb);
    const t = this.G;
    if (this.Ua != t.width || this.Ta != t.height) {
      this.resize(t.width, t.height), this.Ua = t.width, this.Ta = t.height;
    }
    y.call(this);
  };
  l.decodeImage = function(t, u) {
    t = l.decodeImageSkia(t);
    u(t);
  };
  let q = l.Renderer.prototype.align;
  l.Renderer.prototype.align = function(t, u, z, C, E = 1.0) {
    q.call(this, t, u, z, C, E);
  };
};
var pa = Object.assign({}, l), qa = "./this.program", ra = "", sa, ta;
if (da || ea) {
  ea ? ra = self.location.href : "undefined" != typeof document && document.currentScript && (ra = document.currentScript.src), _scriptName && (ra = _scriptName), ra.startsWith("blob:") ? ra = "" : ra = ra.substr(0, ra.replace(/[?#].*/, "").lastIndexOf("/") + 1), ea && (ta = a => {
    var b = new XMLHttpRequest();
    b.open("GET", a, !1);
    b.responseType = "arraybuffer";
    b.send(null);
    return new Uint8Array(b.response);
  }), sa = (a, b, c) => {
    if (ua(a)) {
      var d = new XMLHttpRequest();
      d.open("GET", a, !0);
      d.responseType = "arraybuffer";
      d.onload = () => {
        200 == d.status || 0 == d.status && d.response ? b(d.response) : c();
      };
      d.onerror = c;
      d.send(null);
    } else {
      fetch(a, {credentials:"same-origin"}).then(e => e.ok ? e.arrayBuffer() : Promise.reject(Error(e.status + " : " + e.url))).then(b, c);
    }
  };
}
var va = l.print || console.log.bind(console), wa = l.printErr || console.error.bind(console);
Object.assign(l, pa);
pa = null;
l.thisProgram && (qa = l.thisProgram);
var xa;
l.wasmBinary && (xa = l.wasmBinary);
var ya, za = !1, n, v, Aa, Ba, x, A, B, Ca;
function Da() {
  var a = ya.buffer;
  l.HEAP8 = n = new Int8Array(a);
  l.HEAP16 = Aa = new Int16Array(a);
  l.HEAPU8 = v = new Uint8Array(a);
  l.HEAPU16 = Ba = new Uint16Array(a);
  l.HEAP32 = x = new Int32Array(a);
  l.HEAPU32 = A = new Uint32Array(a);
  l.HEAPF32 = B = new Float32Array(a);
  l.HEAPF64 = Ca = new Float64Array(a);
}
var Ea = [], Fa = [], Ga = [];
function Ha() {
  var a = l.preRun.shift();
  Ea.unshift(a);
}
var Ia = 0, Ja = null, Ka = null;
function La(a) {
  l.onAbort?.(a);
  a = "Aborted(" + a + ")";
  wa(a);
  za = !0;
  a = new WebAssembly.RuntimeError(a + ". Build with -sASSERTIONS for more info.");
  ba(a);
  throw a;
}
var Ma = a => a.startsWith("data:application/octet-stream;base64,"), ua = a => a.startsWith("file://"), Na;
function Oa(a) {
  if (a == Na && xa) {
    return new Uint8Array(xa);
  }
  if (ta) {
    return ta(a);
  }
  throw "both async and sync fetching of the wasm failed";
}
function Pa(a) {
  return xa ? Promise.resolve().then(() => Oa(a)) : new Promise((b, c) => {
    sa(a, d => b(new Uint8Array(d)), () => {
      try {
        b(Oa(a));
      } catch (d) {
        c(d);
      }
    });
  });
}
function Qa(a, b, c) {
  return Pa(a).then(d => WebAssembly.instantiate(d, b)).then(c, d => {
    wa(`failed to asynchronously prepare wasm: ${d}`);
    La(d);
  });
}
function Ra(a, b) {
  var c = Na;
  return xa || "function" != typeof WebAssembly.instantiateStreaming || Ma(c) || ua(c) || "function" != typeof fetch ? Qa(c, a, b) : fetch(c, {credentials:"same-origin"}).then(d => WebAssembly.instantiateStreaming(d, a).then(b, function(e) {
    wa(`wasm streaming compile failed: ${e}`);
    wa("falling back to ArrayBuffer instantiation");
    return Qa(c, a, b);
  }));
}
var Sa, Ta, Xa = {719040:(a, b, c, d, e) => {
  if ("undefined" === typeof window || void 0 === (window.AudioContext || window.webkitAudioContext)) {
    return 0;
  }
  if ("undefined" === typeof window.h) {
    window.h = {Ca:0};
    window.h.H = {};
    window.h.H.Aa = a;
    window.h.H.capture = b;
    window.h.H.Ja = c;
    window.h.ga = {};
    window.h.ga.stopped = d;
    window.h.ga.qb = e;
    let f = window.h;
    f.C = [];
    f.fc = function(g) {
      for (var k = 0; k < f.C.length; ++k) {
        if (null == f.C[k]) {
          return f.C[k] = g, k;
        }
      }
      f.C.push(g);
      return f.C.length - 1;
    };
    f.ub = function(g) {
      for (f.C[g] = null; 0 < f.C.length;) {
        if (null == f.C[f.C.length - 1]) {
          f.C.pop();
        } else {
          break;
        }
      }
    };
    f.Gc = function(g) {
      for (var k = 0; k < f.C.length; ++k) {
        if (f.C[k] == g) {
          return f.ub(k);
        }
      }
    };
    f.ra = function(g) {
      return f.C[g];
    };
    f.Ra = ["touchend", "click"];
    f.unlock = function() {
      for (var g = 0; g < f.C.length; ++g) {
        var k = f.C[g];
        null != k && null != k.J && k.state === f.ga.qb && k.J.resume().then(() => {
          Ua(k.kb);
        }, m => {
          console.error("Failed to resume audiocontext", m);
        });
      }
      f.Ra.map(function(m) {
        document.removeEventListener(m, f.unlock, !0);
      });
    };
    f.Ra.map(function(g) {
      document.addEventListener(g, f.unlock, !0);
    });
  }
  window.h.Ca += 1;
  return 1;
}, 721218:() => {
  "undefined" !== typeof window.h && (window.h.Ra.map(function(a) {
    document.removeEventListener(a, window.h.unlock, !0);
  }), --window.h.Ca, 0 === window.h.Ca && delete window.h);
}, 721522:() => void 0 !== navigator.mediaDevices && void 0 !== navigator.mediaDevices.getUserMedia, 721626:() => {
  try {
    var a = new (window.AudioContext || window.webkitAudioContext)(), b = a.sampleRate;
    a.close();
    return b;
  } catch (c) {
    return 0;
  }
}, 721797:(a, b, c, d, e, f) => {
  if ("undefined" === typeof window.h) {
    return -1;
  }
  var g = {}, k = {};
  a == window.h.H.Aa && 0 != c && (k.sampleRate = c);
  g.J = new (window.AudioContext || window.webkitAudioContext)(k);
  g.J.suspend();
  g.state = window.h.ga.stopped;
  c = 0;
  a != window.h.H.Aa && (c = b);
  g.W = g.J.createScriptProcessor(d, c, b);
  g.W.onaudioprocess = function(m) {
    if (null == g.sa || 0 == g.sa.length) {
      g.sa = new Float32Array(B.buffer, e, d * b);
    }
    if (a == window.h.H.capture || a == window.h.H.Ja) {
      for (var p = 0; p < b; p += 1) {
        for (var r = m.inputBuffer.getChannelData(p), w = g.sa, y = 0; y < d; y += 1) {
          w[y * b + p] = r[y];
        }
      }
      Va(f, d, e);
    }
    if (a == window.h.H.Aa || a == window.h.H.Ja) {
      for (Wa(f, d, e), p = 0; p < m.outputBuffer.numberOfChannels; ++p) {
        for (r = m.outputBuffer.getChannelData(p), w = g.sa, y = 0; y < d; y += 1) {
          r[y] = w[y * b + p];
        }
      }
    } else {
      for (p = 0; p < m.outputBuffer.numberOfChannels; ++p) {
        m.outputBuffer.getChannelData(p).fill(0.0);
      }
    }
  };
  a != window.h.H.capture && a != window.h.H.Ja || navigator.mediaDevices.getUserMedia({audio:!0, video:!1}).then(function(m) {
    g.Da = g.J.createMediaStreamSource(m);
    g.Da.connect(g.W);
    g.W.connect(g.J.destination);
  }).catch(function(m) {
    console.log("Failed to get user media: " + m);
  });
  a == window.h.H.Aa && g.W.connect(g.J.destination);
  g.kb = f;
  return window.h.fc(g);
}, 724674:a => window.h.ra(a).J.sampleRate, 724747:a => {
  a = window.h.ra(a);
  void 0 !== a.W && (a.W.onaudioprocess = function() {
  }, a.W.disconnect(), a.W = void 0);
  void 0 !== a.Da && (a.Da.disconnect(), a.Da = void 0);
  a.J.close();
  a.J = void 0;
  a.kb = void 0;
}, 725147:a => {
  window.h.ub(a);
}, 725197:a => {
  a = window.h.ra(a);
  a.J.resume();
  a.state = window.h.ga.qb;
}, 725336:a => {
  a = window.h.ra(a);
  a.J.suspend();
  a.state = window.h.ga.stopped;
}}, Ya = a => {
  for (; 0 < a.length;) {
    a.shift()(l);
  }
};
function Za() {
  var a = x[+$a >> 2];
  $a += 4;
  return a;
}
var ab = (a, b) => {
  for (var c = 0, d = a.length - 1; 0 <= d; d--) {
    var e = a[d];
    "." === e ? a.splice(d, 1) : ".." === e ? (a.splice(d, 1), c++) : c && (a.splice(d, 1), c--);
  }
  if (b) {
    for (; c; c--) {
      a.unshift("..");
    }
  }
  return a;
}, bb = a => {
  var b = "/" === a.charAt(0), c = "/" === a.substr(-1);
  (a = ab(a.split("/").filter(d => !!d), !b).join("/")) || b || (a = ".");
  a && c && (a += "/");
  return (b ? "/" : "") + a;
}, cb = a => {
  var b = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/.exec(a).slice(1);
  a = b[0];
  b = b[1];
  if (!a && !b) {
    return ".";
  }
  b &&= b.substr(0, b.length - 1);
  return a + b;
}, db = a => {
  if ("/" === a) {
    return "/";
  }
  a = bb(a);
  a = a.replace(/\/$/, "");
  var b = a.lastIndexOf("/");
  return -1 === b ? a : a.substr(b + 1);
}, eb = () => {
  if ("object" == typeof crypto && "function" == typeof crypto.getRandomValues) {
    return a => crypto.getRandomValues(a);
  }
  La("initRandomDevice");
}, fb = a => (fb = eb())(a), gb = (...a) => {
  for (var b = "", c = !1, d = a.length - 1; -1 <= d && !c; d--) {
    c = 0 <= d ? a[d] : "/";
    if ("string" != typeof c) {
      throw new TypeError("Arguments to path.resolve must be strings");
    }
    if (!c) {
      return "";
    }
    b = c + "/" + b;
    c = "/" === c.charAt(0);
  }
  b = ab(b.split("/").filter(e => !!e), !c).join("/");
  return (c ? "/" : "") + b || ".";
}, hb = "undefined" != typeof TextDecoder ? new TextDecoder("utf8") : void 0, D = (a, b, c) => {
  var d = b + c;
  for (c = b; a[c] && !(c >= d);) {
    ++c;
  }
  if (16 < c - b && a.buffer && hb) {
    return hb.decode(a.subarray(b, c));
  }
  for (d = ""; b < c;) {
    var e = a[b++];
    if (e & 128) {
      var f = a[b++] & 63;
      if (192 == (e & 224)) {
        d += String.fromCharCode((e & 31) << 6 | f);
      } else {
        var g = a[b++] & 63;
        e = 224 == (e & 240) ? (e & 15) << 12 | f << 6 | g : (e & 7) << 18 | f << 12 | g << 6 | a[b++] & 63;
        65536 > e ? d += String.fromCharCode(e) : (e -= 65536, d += String.fromCharCode(55296 | e >> 10, 56320 | e & 1023));
      }
    } else {
      d += String.fromCharCode(e);
    }
  }
  return d;
}, ib = [], jb = a => {
  for (var b = 0, c = 0; c < a.length; ++c) {
    var d = a.charCodeAt(c);
    127 >= d ? b++ : 2047 >= d ? b += 2 : 55296 <= d && 57343 >= d ? (b += 4, ++c) : b += 3;
  }
  return b;
}, kb = (a, b, c, d) => {
  if (!(0 < d)) {
    return 0;
  }
  var e = c;
  d = c + d - 1;
  for (var f = 0; f < a.length; ++f) {
    var g = a.charCodeAt(f);
    if (55296 <= g && 57343 >= g) {
      var k = a.charCodeAt(++f);
      g = 65536 + ((g & 1023) << 10) | k & 1023;
    }
    if (127 >= g) {
      if (c >= d) {
        break;
      }
      b[c++] = g;
    } else {
      if (2047 >= g) {
        if (c + 1 >= d) {
          break;
        }
        b[c++] = 192 | g >> 6;
      } else {
        if (65535 >= g) {
          if (c + 2 >= d) {
            break;
          }
          b[c++] = 224 | g >> 12;
        } else {
          if (c + 3 >= d) {
            break;
          }
          b[c++] = 240 | g >> 18;
          b[c++] = 128 | g >> 12 & 63;
        }
        b[c++] = 128 | g >> 6 & 63;
      }
      b[c++] = 128 | g & 63;
    }
  }
  b[c] = 0;
  return c - e;
};
function lb(a, b) {
  var c = Array(jb(a) + 1);
  a = kb(a, c, 0, c.length);
  b && (c.length = a);
  return c;
}
var mb = [];
function nb(a, b) {
  mb[a] = {input:[], F:[], T:b};
  ob(a, pb);
}
var pb = {open(a) {
  var b = mb[a.node.Ba];
  if (!b) {
    throw new F(43);
  }
  a.s = b;
  a.seekable = !1;
}, close(a) {
  a.s.T.qa(a.s);
}, qa(a) {
  a.s.T.qa(a.s);
}, read(a, b, c, d) {
  if (!a.s || !a.s.T.cb) {
    throw new F(60);
  }
  for (var e = 0, f = 0; f < d; f++) {
    try {
      var g = a.s.T.cb(a.s);
    } catch (k) {
      throw new F(29);
    }
    if (void 0 === g && 0 === e) {
      throw new F(6);
    }
    if (null === g || void 0 === g) {
      break;
    }
    e++;
    b[c + f] = g;
  }
  e && (a.node.timestamp = Date.now());
  return e;
}, write(a, b, c, d) {
  if (!a.s || !a.s.T.Ma) {
    throw new F(60);
  }
  try {
    for (var e = 0; e < d; e++) {
      a.s.T.Ma(a.s, b[c + e]);
    }
  } catch (f) {
    throw new F(29);
  }
  d && (a.node.timestamp = Date.now());
  return e;
},}, qb = {cb() {
  a: {
    if (!ib.length) {
      var a = null;
      "undefined" != typeof window && "function" == typeof window.prompt && (a = window.prompt("Input: "), null !== a && (a += "\n"));
      if (!a) {
        a = null;
        break a;
      }
      ib = lb(a, !0);
    }
    a = ib.shift();
  }
  return a;
}, Ma(a, b) {
  null === b || 10 === b ? (va(D(a.F, 0)), a.F = []) : 0 != b && a.F.push(b);
}, qa(a) {
  a.F && 0 < a.F.length && (va(D(a.F, 0)), a.F = []);
}, Rb() {
  return {oc:25856, qc:5, nc:191, pc:35387, mc:[3, 28, 127, 21, 4, 0, 1, 0, 17, 19, 26, 0, 18, 15, 23, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,]};
}, Sb() {
  return 0;
}, Tb() {
  return [24, 80];
},}, rb = {Ma(a, b) {
  null === b || 10 === b ? (wa(D(a.F, 0)), a.F = []) : 0 != b && a.F.push(b);
}, qa(a) {
  a.F && 0 < a.F.length && (wa(D(a.F, 0)), a.F = []);
},};
function sb(a, b) {
  var c = a.l ? a.l.length : 0;
  c >= b || (b = Math.max(b, c * (1048576 > c ? 2.0 : 1.125) >>> 0), 0 != c && (b = Math.max(b, 256)), c = a.l, a.l = new Uint8Array(b), 0 < a.v && a.l.set(c.subarray(0, a.v), 0));
}
var G = {M:null, S() {
  return G.createNode(null, "/", 16895, 0);
}, createNode(a, b, c, d) {
  if (24576 === (c & 61440) || 4096 === (c & 61440)) {
    throw new F(63);
  }
  G.M || (G.M = {dir:{node:{V:G.j.V, O:G.j.O, ja:G.j.ja, ya:G.j.ya, ob:G.j.ob, tb:G.j.tb, pb:G.j.pb, nb:G.j.nb, Ea:G.j.Ea}, stream:{Z:G.m.Z}}, file:{node:{V:G.j.V, O:G.j.O}, stream:{Z:G.m.Z, read:G.m.read, write:G.m.write, Va:G.m.Va, gb:G.m.gb, ib:G.m.ib}}, link:{node:{V:G.j.V, O:G.j.O, ka:G.j.ka}, stream:{}}, Wa:{node:{V:G.j.V, O:G.j.O}, stream:tb}});
  c = ub(a, b, c, d);
  16384 === (c.mode & 61440) ? (c.j = G.M.dir.node, c.m = G.M.dir.stream, c.l = {}) : 32768 === (c.mode & 61440) ? (c.j = G.M.file.node, c.m = G.M.file.stream, c.v = 0, c.l = null) : 40960 === (c.mode & 61440) ? (c.j = G.M.link.node, c.m = G.M.link.stream) : 8192 === (c.mode & 61440) && (c.j = G.M.Wa.node, c.m = G.M.Wa.stream);
  c.timestamp = Date.now();
  a && (a.l[b] = c, a.timestamp = c.timestamp);
  return c;
}, vc(a) {
  return a.l ? a.l.subarray ? a.l.subarray(0, a.v) : new Uint8Array(a.l) : new Uint8Array(0);
}, j:{V(a) {
  var b = {};
  b.tc = 8192 === (a.mode & 61440) ? a.id : 1;
  b.xc = a.id;
  b.mode = a.mode;
  b.Cc = 1;
  b.uid = 0;
  b.wc = 0;
  b.Ba = a.Ba;
  16384 === (a.mode & 61440) ? b.size = 4096 : 32768 === (a.mode & 61440) ? b.size = a.v : 40960 === (a.mode & 61440) ? b.size = a.link.length : b.size = 0;
  b.kc = new Date(a.timestamp);
  b.Ac = new Date(a.timestamp);
  b.rc = new Date(a.timestamp);
  b.Bb = 4096;
  b.lc = Math.ceil(b.size / b.Bb);
  return b;
}, O(a, b) {
  void 0 !== b.mode && (a.mode = b.mode);
  void 0 !== b.timestamp && (a.timestamp = b.timestamp);
  if (void 0 !== b.size && (b = b.size, a.v != b)) {
    if (0 == b) {
      a.l = null, a.v = 0;
    } else {
      var c = a.l;
      a.l = new Uint8Array(b);
      c && a.l.set(c.subarray(0, Math.min(b, a.v)));
      a.v = b;
    }
  }
}, ja() {
  throw vb[44];
}, ya(a, b, c, d) {
  return G.createNode(a, b, c, d);
}, ob(a, b, c) {
  if (16384 === (a.mode & 61440)) {
    try {
      var d = wb(b, c);
    } catch (f) {
    }
    if (d) {
      for (var e in d.l) {
        throw new F(55);
      }
    }
  }
  delete a.parent.l[a.name];
  a.parent.timestamp = Date.now();
  a.name = c;
  b.l[c] = a;
  b.timestamp = a.parent.timestamp;
}, tb(a, b) {
  delete a.l[b];
  a.timestamp = Date.now();
}, pb(a, b) {
  var c = wb(a, b), d;
  for (d in c.l) {
    throw new F(55);
  }
  delete a.l[b];
  a.timestamp = Date.now();
}, nb(a) {
  var b = [".", ".."], c;
  for (c of Object.keys(a.l)) {
    b.push(c);
  }
  return b;
}, Ea(a, b, c) {
  a = G.createNode(a, b, 41471, 0);
  a.link = c;
  return a;
}, ka(a) {
  if (40960 !== (a.mode & 61440)) {
    throw new F(28);
  }
  return a.link;
},}, m:{read(a, b, c, d, e) {
  var f = a.node.l;
  if (e >= a.node.v) {
    return 0;
  }
  a = Math.min(a.node.v - e, d);
  if (8 < a && f.subarray) {
    b.set(f.subarray(e, e + a), c);
  } else {
    for (d = 0; d < a; d++) {
      b[c + d] = f[e + d];
    }
  }
  return a;
}, write(a, b, c, d, e, f) {
  b.buffer === n.buffer && (f = !1);
  if (!d) {
    return 0;
  }
  a = a.node;
  a.timestamp = Date.now();
  if (b.subarray && (!a.l || a.l.subarray)) {
    if (f) {
      return a.l = b.subarray(c, c + d), a.v = d;
    }
    if (0 === a.v && 0 === e) {
      return a.l = b.slice(c, c + d), a.v = d;
    }
    if (e + d <= a.v) {
      return a.l.set(b.subarray(c, c + d), e), d;
    }
  }
  sb(a, e + d);
  if (a.l.subarray && b.subarray) {
    a.l.set(b.subarray(c, c + d), e);
  } else {
    for (f = 0; f < d; f++) {
      a.l[e + f] = b[c + f];
    }
  }
  a.v = Math.max(a.v, e + d);
  return d;
}, Z(a, b, c) {
  1 === c ? b += a.position : 2 === c && 32768 === (a.node.mode & 61440) && (b += a.node.v);
  if (0 > b) {
    throw new F(28);
  }
  return b;
}, Va(a, b, c) {
  sb(a.node, b + c);
  a.node.v = Math.max(a.node.v, b + c);
}, gb(a, b, c, d, e) {
  if (32768 !== (a.node.mode & 61440)) {
    throw new F(43);
  }
  a = a.node.l;
  if (e & 2 || a.buffer !== n.buffer) {
    if (0 < c || c + b < a.length) {
      a.subarray ? a = a.subarray(c, c + b) : a = Array.prototype.slice.call(a, c, c + b);
    }
    c = !0;
    b = 65536 * Math.ceil(b / 65536);
    (e = xb(65536, b)) ? (v.fill(0, e, e + b), b = e) : b = 0;
    if (!b) {
      throw new F(48);
    }
    n.set(a, b);
  } else {
    c = !1, b = a.byteOffset;
  }
  return {o:b, jc:c};
}, ib(a, b, c, d) {
  G.m.write(a, b, 0, d, c, !1);
  return 0;
},},}, zb = (a, b) => {
  var c = 0;
  a && (c |= 365);
  b && (c |= 146);
  return c;
}, Ab = null, Bb = {}, Cb = [], Db = 1, Eb = null, Fb = !0, F = class {
  constructor(a) {
    this.name = "ErrnoError";
    this.Y = a;
  }
}, vb = {}, Gb = class {
  constructor() {
    this.h = {};
    this.node = null;
  }
  get flags() {
    return this.h.flags;
  }
  set flags(a) {
    this.h.flags = a;
  }
  get position() {
    return this.h.position;
  }
  set position(a) {
    this.h.position = a;
  }
}, Hb = class {
  constructor(a, b, c, d) {
    a ||= this;
    this.parent = a;
    this.S = a.S;
    this.za = null;
    this.id = Db++;
    this.name = b;
    this.mode = c;
    this.j = {};
    this.m = {};
    this.Ba = d;
  }
  get read() {
    return 365 === (this.mode & 365);
  }
  set read(a) {
    a ? this.mode |= 365 : this.mode &= -366;
  }
  get write() {
    return 146 === (this.mode & 146);
  }
  set write(a) {
    a ? this.mode |= 146 : this.mode &= -147;
  }
};
function Ib(a, b = {}) {
  a = gb(a);
  if (!a) {
    return {path:"", node:null};
  }
  b = Object.assign({bb:!0, Oa:0}, b);
  if (8 < b.Oa) {
    throw new F(32);
  }
  a = a.split("/").filter(g => !!g);
  for (var c = Ab, d = "/", e = 0; e < a.length; e++) {
    var f = e === a.length - 1;
    if (f && b.parent) {
      break;
    }
    c = wb(c, a[e]);
    d = bb(d + "/" + a[e]);
    c.za && (!f || f && b.bb) && (c = c.za.root);
    if (!f || b.ab) {
      for (f = 0; 40960 === (c.mode & 61440);) {
        if (c = Jb(d), d = gb(cb(d), c), c = Ib(d, {Oa:b.Oa + 1}).node, 40 < f++) {
          throw new F(32);
        }
      }
    }
  }
  return {path:d, node:c};
}
function Kb(a) {
  for (var b;;) {
    if (a === a.parent) {
      return a = a.S.hb, b ? "/" !== a[a.length - 1] ? `${a}/${b}` : a + b : a;
    }
    b = b ? `${a.name}/${b}` : a.name;
    a = a.parent;
  }
}
function Lb(a, b) {
  for (var c = 0, d = 0; d < b.length; d++) {
    c = (c << 5) - c + b.charCodeAt(d) | 0;
  }
  return (a + c >>> 0) % Eb.length;
}
function wb(a, b) {
  var c = 16384 === (a.mode & 61440) ? (c = Mb(a, "x")) ? c : a.j.ja ? 0 : 2 : 54;
  if (c) {
    throw new F(c);
  }
  for (c = Eb[Lb(a.id, b)]; c; c = c.Vb) {
    var d = c.name;
    if (c.parent.id === a.id && d === b) {
      return c;
    }
  }
  return a.j.ja(a, b);
}
function ub(a, b, c, d) {
  a = new Hb(a, b, c, d);
  b = Lb(a.parent.id, a.name);
  a.Vb = Eb[b];
  return Eb[b] = a;
}
function Nb(a) {
  var b = ["r", "w", "rw"][a & 3];
  a & 512 && (b += "w");
  return b;
}
function Mb(a, b) {
  if (Fb) {
    return 0;
  }
  if (!b.includes("r") || a.mode & 292) {
    if (b.includes("w") && !(a.mode & 146) || b.includes("x") && !(a.mode & 73)) {
      return 2;
    }
  } else {
    return 2;
  }
  return 0;
}
function Ob(a, b) {
  try {
    return wb(a, b), 20;
  } catch (c) {
  }
  return Mb(a, "wx");
}
function Pb(a) {
  a = Cb[a];
  if (!a) {
    throw new F(8);
  }
  return a;
}
function Qb(a, b = -1) {
  a = Object.assign(new Gb(), a);
  if (-1 == b) {
    a: {
      for (b = 0; 4096 >= b; b++) {
        if (!Cb[b]) {
          break a;
        }
      }
      throw new F(33);
    }
  }
  a.U = b;
  return Cb[b] = a;
}
function Rb(a, b = -1) {
  a = Qb(a, b);
  a.m?.uc?.(a);
  return a;
}
var tb = {open(a) {
  a.m = Bb[a.node.Ba].m;
  a.m.open?.(a);
}, Z() {
  throw new F(70);
},};
function ob(a, b) {
  Bb[a] = {m:b};
}
function Sb(a, b) {
  var c = "/" === b;
  if (c && Ab) {
    throw new F(10);
  }
  if (!c && b) {
    var d = Ib(b, {bb:!1});
    b = d.path;
    d = d.node;
    if (d.za) {
      throw new F(10);
    }
    if (16384 !== (d.mode & 61440)) {
      throw new F(54);
    }
  }
  b = {type:a, Ec:{}, hb:b, Ub:[]};
  a = a.S(b);
  a.S = b;
  b.root = a;
  c ? Ab = a : d && (d.za = b, d.S && d.S.Ub.push(b));
}
function Tb(a, b, c) {
  var d = Ib(a, {parent:!0}).node;
  a = db(a);
  if (!a || "." === a || ".." === a) {
    throw new F(28);
  }
  var e = Ob(d, a);
  if (e) {
    throw new F(e);
  }
  if (!d.j.ya) {
    throw new F(63);
  }
  return d.j.ya(d, a, b, c);
}
function Ub(a) {
  return Tb(a, 16895, 0);
}
function Vb(a, b, c) {
  "undefined" == typeof c && (c = b, b = 438);
  Tb(a, b | 8192, c);
}
function Wb(a, b) {
  if (!gb(a)) {
    throw new F(44);
  }
  var c = Ib(b, {parent:!0}).node;
  if (!c) {
    throw new F(44);
  }
  b = db(b);
  var d = Ob(c, b);
  if (d) {
    throw new F(d);
  }
  if (!c.j.Ea) {
    throw new F(63);
  }
  c.j.Ea(c, b, a);
}
function Jb(a) {
  a = Ib(a).node;
  if (!a) {
    throw new F(44);
  }
  if (!a.j.ka) {
    throw new F(28);
  }
  return gb(Kb(a.parent), a.j.ka(a));
}
function Xb(a, b, c) {
  if ("" === a) {
    throw new F(44);
  }
  if ("string" == typeof b) {
    var d = {r:0, "r+":2, w:577, "w+":578, a:1089, "a+":1090,}[b];
    if ("undefined" == typeof d) {
      throw Error(`Unknown file open mode: ${b}`);
    }
    b = d;
  }
  c = b & 64 ? ("undefined" == typeof c ? 438 : c) & 4095 | 32768 : 0;
  if ("object" == typeof a) {
    var e = a;
  } else {
    a = bb(a);
    try {
      e = Ib(a, {ab:!(b & 131072)}).node;
    } catch (f) {
    }
  }
  d = !1;
  if (b & 64) {
    if (e) {
      if (b & 128) {
        throw new F(20);
      }
    } else {
      e = Tb(a, c, 0), d = !0;
    }
  }
  if (!e) {
    throw new F(44);
  }
  8192 === (e.mode & 61440) && (b &= -513);
  if (b & 65536 && 16384 !== (e.mode & 61440)) {
    throw new F(54);
  }
  if (!d && (c = e ? 40960 === (e.mode & 61440) ? 32 : 16384 === (e.mode & 61440) && ("r" !== Nb(b) || b & 512) ? 31 : Mb(e, Nb(b)) : 44)) {
    throw new F(c);
  }
  if (b & 512 && !d) {
    c = e;
    c = "string" == typeof c ? Ib(c, {ab:!0}).node : c;
    if (!c.j.O) {
      throw new F(63);
    }
    if (16384 === (c.mode & 61440)) {
      throw new F(31);
    }
    if (32768 !== (c.mode & 61440)) {
      throw new F(28);
    }
    if (d = Mb(c, "w")) {
      throw new F(d);
    }
    c.j.O(c, {size:0, timestamp:Date.now()});
  }
  b &= -131713;
  e = Qb({node:e, path:Kb(e), flags:b, seekable:!0, position:0, m:e.m, hc:[], error:!1});
  e.m.open && e.m.open(e);
  !l.logReadFiles || b & 1 || (Yb ||= {}, a in Yb || (Yb[a] = 1));
  return e;
}
function Zb(a, b, c) {
  if (null === a.U) {
    throw new F(8);
  }
  if (!a.seekable || !a.m.Z) {
    throw new F(70);
  }
  if (0 != c && 1 != c && 2 != c) {
    throw new F(28);
  }
  a.position = a.m.Z(a, b, c);
  a.hc = [];
}
var $b;
function ac(a, b, c) {
  a = bb("/dev/" + a);
  var d = zb(!!b, !!c);
  bc ||= 64;
  var e = bc++ << 8 | 0;
  ob(e, {open(f) {
    f.seekable = !1;
  }, close() {
    c?.buffer?.length && c(10);
  }, read(f, g, k, m) {
    for (var p = 0, r = 0; r < m; r++) {
      try {
        var w = b();
      } catch (y) {
        throw new F(29);
      }
      if (void 0 === w && 0 === p) {
        throw new F(6);
      }
      if (null === w || void 0 === w) {
        break;
      }
      p++;
      g[k + r] = w;
    }
    p && (f.node.timestamp = Date.now());
    return p;
  }, write(f, g, k, m) {
    for (var p = 0; p < m; p++) {
      try {
        c(g[k + p]);
      } catch (r) {
        throw new F(29);
      }
    }
    m && (f.node.timestamp = Date.now());
    return p;
  }});
  Vb(a, d, e);
}
var bc, cc = {}, Yb, $a = void 0, dc = (a, b) => Object.defineProperty(b, "name", {value:a}), ec = [], fc = [], H, gc = a => {
  if (!a) {
    throw new H("Cannot use deleted val. handle = " + a);
  }
  return fc[a];
}, hc = a => {
  switch(a) {
    case void 0:
      return 2;
    case null:
      return 4;
    case !0:
      return 6;
    case !1:
      return 8;
    default:
      const b = ec.pop() || fc.length;
      fc[b] = a;
      fc[b + 1] = 1;
      return b;
  }
}, ic = a => {
  var b = Error, c = dc(a, function(d) {
    this.name = a;
    this.message = d;
    d = Error(d).stack;
    void 0 !== d && (this.stack = this.toString() + "\n" + d.replace(/^Error(:[^\n]*)?\n/, ""));
  });
  c.prototype = Object.create(b.prototype);
  c.prototype.constructor = c;
  c.prototype.toString = function() {
    return void 0 === this.message ? this.name : `${this.name}: ${this.message}`;
  };
  return c;
}, jc, kc, I = a => {
  for (var b = ""; v[a];) {
    b += kc[v[a++]];
  }
  return b;
}, lc = [], mc = () => {
  for (; lc.length;) {
    var a = lc.pop();
    a.g.fa = !1;
    a["delete"]();
  }
}, nc, oc = {}, pc = (a, b) => {
  if (void 0 === b) {
    throw new H("ptr should not be undefined");
  }
  for (; a.B;) {
    b = a.ma(b), a = a.B;
  }
  return b;
}, qc = {}, tc = a => {
  a = rc(a);
  var b = I(a);
  sc(a);
  return b;
}, uc = (a, b) => {
  var c = qc[a];
  if (void 0 === c) {
    throw a = `${b} has unknown type ${tc(a)}`, new H(a);
  }
  return c;
}, vc = () => {
}, wc = !1, xc = (a, b, c) => {
  if (b === c) {
    return a;
  }
  if (void 0 === c.B) {
    return null;
  }
  a = xc(a, b, c.B);
  return null === a ? null : c.Eb(a);
}, yc = {}, zc = (a, b) => {
  b = pc(a, b);
  return oc[b];
}, Ac, Cc = (a, b) => {
  if (!b.u || !b.o) {
    throw new Ac("makeClassHandle requires ptr and ptrType");
  }
  if (!!b.I !== !!b.D) {
    throw new Ac("Both smartPtrType and smartPtr must be specified");
  }
  b.count = {value:1};
  return Bc(Object.create(a, {g:{value:b, writable:!0,},}));
}, Bc = a => {
  if ("undefined" === typeof FinalizationRegistry) {
    return Bc = b => b, a;
  }
  wc = new FinalizationRegistry(b => {
    b = b.g;
    --b.count.value;
    0 === b.count.value && (b.D ? b.I.N(b.D) : b.u.i.N(b.o));
  });
  Bc = b => {
    var c = b.g;
    c.D && wc.register(b, {g:c}, b);
    return b;
  };
  vc = b => {
    wc.unregister(b);
  };
  return Bc(a);
}, Dc = {}, Ec = a => {
  for (; a.length;) {
    var b = a.pop();
    a.pop()(b);
  }
};
function Fc(a) {
  return this.fromWireType(A[a >> 2]);
}
var Gc = {}, Hc = {}, J = (a, b, c) => {
  function d(k) {
    k = c(k);
    if (k.length !== a.length) {
      throw new Ac("Mismatched type converter count");
    }
    for (var m = 0; m < a.length; ++m) {
      Ic(a[m], k[m]);
    }
  }
  a.forEach(function(k) {
    Hc[k] = b;
  });
  var e = Array(b.length), f = [], g = 0;
  b.forEach((k, m) => {
    qc.hasOwnProperty(k) ? e[m] = qc[k] : (f.push(k), Gc.hasOwnProperty(k) || (Gc[k] = []), Gc[k].push(() => {
      e[m] = qc[k];
      ++g;
      g === f.length && d(e);
    }));
  });
  0 === f.length && d(e);
};
function Jc(a, b, c = {}) {
  var d = b.name;
  if (!a) {
    throw new H(`type "${d}" must have a positive integer typeid pointer`);
  }
  if (qc.hasOwnProperty(a)) {
    if (c.Ob) {
      return;
    }
    throw new H(`Cannot register type '${d}' twice`);
  }
  qc[a] = b;
  delete Hc[a];
  Gc.hasOwnProperty(a) && (b = Gc[a], delete Gc[a], b.forEach(e => e()));
}
function Ic(a, b, c = {}) {
  if (!("argPackAdvance" in b)) {
    throw new TypeError("registerType registeredInstance requires argPackAdvance");
  }
  return Jc(a, b, c);
}
var Kc = a => {
  throw new H(a.g.u.i.name + " instance already deleted");
};
function Lc() {
}
var Mc = (a, b, c) => {
  if (void 0 === a[b].A) {
    var d = a[b];
    a[b] = function(...e) {
      if (!a[b].A.hasOwnProperty(e.length)) {
        throw new H(`Function '${c}' called with an invalid number of arguments (${e.length}) - expects one of (${a[b].A})!`);
      }
      return a[b].A[e.length].apply(this, e);
    };
    a[b].A = [];
    a[b].A[d.da] = d;
  }
}, Nc = (a, b, c) => {
  if (l.hasOwnProperty(a)) {
    if (void 0 === c || void 0 !== l[a].A && void 0 !== l[a].A[c]) {
      throw new H(`Cannot register public name '${a}' twice`);
    }
    Mc(l, a, a);
    if (l.hasOwnProperty(c)) {
      throw new H(`Cannot register multiple overloads of a function with the same number of arguments (${c})!`);
    }
    l[a].A[c] = b;
  } else {
    l[a] = b, void 0 !== c && (l[a].Dc = c);
  }
}, Oc = a => {
  if (void 0 === a) {
    return "_unknown";
  }
  a = a.replace(/[^a-zA-Z0-9_]/g, "$");
  var b = a.charCodeAt(0);
  return 48 <= b && 57 >= b ? `_${a}` : a;
};
function Pc(a, b, c, d, e, f, g, k) {
  this.name = a;
  this.constructor = b;
  this.L = c;
  this.N = d;
  this.B = e;
  this.Jb = f;
  this.ma = g;
  this.Eb = k;
  this.lb = [];
}
var Qc = (a, b, c) => {
  for (; b !== c;) {
    if (!b.ma) {
      throw new H(`Expected null or instance of ${c.name}, got an instance of ${b.name}`);
    }
    a = b.ma(a);
    b = b.B;
  }
  return a;
};
function Rc(a, b) {
  if (null === b) {
    if (this.La) {
      throw new H(`null is not a valid ${this.name}`);
    }
    return 0;
  }
  if (!b.g) {
    throw new H(`Cannot pass "${Sc(b)}" as a ${this.name}`);
  }
  if (!b.g.o) {
    throw new H(`Cannot pass deleted object as a pointer of type ${this.name}`);
  }
  return Qc(b.g.o, b.g.u.i, this.i);
}
function Tc(a, b) {
  if (null === b) {
    if (this.La) {
      throw new H(`null is not a valid ${this.name}`);
    }
    if (this.ua) {
      var c = this.Na();
      null !== a && a.push(this.N, c);
      return c;
    }
    return 0;
  }
  if (!b || !b.g) {
    throw new H(`Cannot pass "${Sc(b)}" as a ${this.name}`);
  }
  if (!b.g.o) {
    throw new H(`Cannot pass deleted object as a pointer of type ${this.name}`);
  }
  if (!this.ta && b.g.u.ta) {
    throw new H(`Cannot convert argument of type ${b.g.I ? b.g.I.name : b.g.u.name} to parameter type ${this.name}`);
  }
  c = Qc(b.g.o, b.g.u.i, this.i);
  if (this.ua) {
    if (void 0 === b.g.D) {
      throw new H("Passing raw pointer to smart pointer is illegal");
    }
    switch(this.ac) {
      case 0:
        if (b.g.I === this) {
          c = b.g.D;
        } else {
          throw new H(`Cannot convert argument of type ${b.g.I ? b.g.I.name : b.g.u.name} to parameter type ${this.name}`);
        }
        break;
      case 1:
        c = b.g.D;
        break;
      case 2:
        if (b.g.I === this) {
          c = b.g.D;
        } else {
          var d = b.clone();
          c = this.Xb(c, hc(() => d["delete"]()));
          null !== a && a.push(this.N, c);
        }
        break;
      default:
        throw new H("Unsupporting sharing policy");
    }
  }
  return c;
}
function Uc(a, b) {
  if (null === b) {
    if (this.La) {
      throw new H(`null is not a valid ${this.name}`);
    }
    return 0;
  }
  if (!b.g) {
    throw new H(`Cannot pass "${Sc(b)}" as a ${this.name}`);
  }
  if (!b.g.o) {
    throw new H(`Cannot pass deleted object as a pointer of type ${this.name}`);
  }
  if (b.g.u.ta) {
    throw new H(`Cannot convert argument of type ${b.g.u.name} to parameter type ${this.name}`);
  }
  return Qc(b.g.o, b.g.u.i, this.i);
}
function Vc(a, b, c, d, e, f, g, k, m, p, r) {
  this.name = a;
  this.i = b;
  this.La = c;
  this.ta = d;
  this.ua = e;
  this.Wb = f;
  this.ac = g;
  this.mb = k;
  this.Na = m;
  this.Xb = p;
  this.N = r;
  e || void 0 !== b.B ? this.toWireType = Tc : (this.toWireType = d ? Rc : Uc, this.K = null);
}
var Wc = (a, b, c) => {
  if (!l.hasOwnProperty(a)) {
    throw new Ac("Replacing nonexistent public symbol");
  }
  void 0 !== l[a].A && void 0 !== c ? l[a].A[c] = b : (l[a] = b, l[a].da = c);
}, Xc = [], Yc, K = a => {
  var b = Xc[a];
  b || (a >= Xc.length && (Xc.length = a + 1), Xc[a] = b = Yc.get(a));
  return b;
}, Zc = (a, b, c = []) => {
  a.includes("j") ? (a = a.replace(/p/g, "i"), b = (0,l["dynCall_" + a])(b, ...c)) : b = K(b)(...c);
  return b;
}, $c = (a, b) => (...c) => Zc(a, b, c), P = (a, b) => {
  a = I(a);
  var c = a.includes("j") ? $c(a, b) : K(b);
  if ("function" != typeof c) {
    throw new H(`unknown function pointer with signature ${a}: ${b}`);
  }
  return c;
}, ad, bd = (a, b) => {
  function c(f) {
    e[f] || qc[f] || (Hc[f] ? Hc[f].forEach(c) : (d.push(f), e[f] = !0));
  }
  var d = [], e = {};
  b.forEach(c);
  throw new ad(`${a}: ` + d.map(tc).join([", "]));
};
function cd(a) {
  for (var b = 1; b < a.length; ++b) {
    if (null !== a[b] && void 0 === a[b].K) {
      return !0;
    }
  }
  return !1;
}
function dd(a, b, c, d, e) {
  var f = b.length;
  if (2 > f) {
    throw new H("argTypes array size mismatch! Must at least get return value and 'this' types!");
  }
  var g = null !== b[1] && null !== c, k = cd(b), m = "void" !== b[0].name, p = f - 2, r = Array(p), w = [], y = [];
  return dc(a, function(...q) {
    if (q.length !== p) {
      throw new H(`function ${a} called with ${q.length} arguments, expected ${p}`);
    }
    y.length = 0;
    w.length = g ? 2 : 1;
    w[0] = e;
    if (g) {
      var t = b[1].toWireType(y, this);
      w[1] = t;
    }
    for (var u = 0; u < p; ++u) {
      r[u] = b[u + 2].toWireType(y, q[u]), w.push(r[u]);
    }
    q = d(...w);
    if (k) {
      Ec(y);
    } else {
      for (u = g ? 1 : 2; u < b.length; u++) {
        var z = 1 === u ? t : r[u - 2];
        null !== b[u].K && b[u].K(z);
      }
    }
    t = m ? b[0].fromWireType(q) : void 0;
    return t;
  });
}
var ed = (a, b) => {
  for (var c = [], d = 0; d < a; d++) {
    c.push(A[b + 4 * d >> 2]);
  }
  return c;
}, fd = a => {
  a = a.trim();
  const b = a.indexOf("(");
  return -1 !== b ? a.substr(0, b) : a;
}, gd = (a, b, c) => {
  if (!(a instanceof Object)) {
    throw new H(`${c} with invalid "this": ${a}`);
  }
  if (!(a instanceof b.i.constructor)) {
    throw new H(`${c} incompatible with "this" of type ${a.constructor.name}`);
  }
  if (!a.g.o) {
    throw new H(`cannot call emscripten binding method ${c} on deleted object`);
  }
  return Qc(a.g.o, a.g.u.i, b.i);
}, hd = a => {
  9 < a && 0 === --fc[a + 1] && (fc[a] = void 0, ec.push(a));
}, jd = {name:"emscripten::val", fromWireType:a => {
  var b = gc(a);
  hd(a);
  return b;
}, toWireType:(a, b) => hc(b), argPackAdvance:8, readValueFromPointer:Fc, K:null,}, kd = (a, b, c) => {
  switch(b) {
    case 1:
      return c ? function(d) {
        return this.fromWireType(n[d]);
      } : function(d) {
        return this.fromWireType(v[d]);
      };
    case 2:
      return c ? function(d) {
        return this.fromWireType(Aa[d >> 1]);
      } : function(d) {
        return this.fromWireType(Ba[d >> 1]);
      };
    case 4:
      return c ? function(d) {
        return this.fromWireType(x[d >> 2]);
      } : function(d) {
        return this.fromWireType(A[d >> 2]);
      };
    default:
      throw new TypeError(`invalid integer width (${b}): ${a}`);
  }
}, Sc = a => {
  if (null === a) {
    return "null";
  }
  var b = typeof a;
  return "object" === b || "array" === b || "function" === b ? a.toString() : "" + a;
}, ld = (a, b) => {
  switch(b) {
    case 4:
      return function(c) {
        return this.fromWireType(B[c >> 2]);
      };
    case 8:
      return function(c) {
        return this.fromWireType(Ca[c >> 3]);
      };
    default:
      throw new TypeError(`invalid float width (${b}): ${a}`);
  }
}, md = (a, b, c) => {
  switch(b) {
    case 1:
      return c ? d => n[d] : d => v[d];
    case 2:
      return c ? d => Aa[d >> 1] : d => Ba[d >> 1];
    case 4:
      return c ? d => x[d >> 2] : d => A[d >> 2];
    default:
      throw new TypeError(`invalid integer width (${b}): ${a}`);
  }
}, nd = "undefined" != typeof TextDecoder ? new TextDecoder("utf-16le") : void 0, od = (a, b) => {
  var c = a >> 1;
  for (var d = c + b / 2; !(c >= d) && Ba[c];) {
    ++c;
  }
  c <<= 1;
  if (32 < c - a && nd) {
    return nd.decode(v.subarray(a, c));
  }
  c = "";
  for (d = 0; !(d >= b / 2); ++d) {
    var e = Aa[a + 2 * d >> 1];
    if (0 == e) {
      break;
    }
    c += String.fromCharCode(e);
  }
  return c;
}, pd = (a, b, c) => {
  c ??= 2147483647;
  if (2 > c) {
    return 0;
  }
  c -= 2;
  var d = b;
  c = c < 2 * a.length ? c / 2 : a.length;
  for (var e = 0; e < c; ++e) {
    Aa[b >> 1] = a.charCodeAt(e), b += 2;
  }
  Aa[b >> 1] = 0;
  return b - d;
}, qd = a => 2 * a.length, rd = (a, b) => {
  for (var c = 0, d = ""; !(c >= b / 4);) {
    var e = x[a + 4 * c >> 2];
    if (0 == e) {
      break;
    }
    ++c;
    65536 <= e ? (e -= 65536, d += String.fromCharCode(55296 | e >> 10, 56320 | e & 1023)) : d += String.fromCharCode(e);
  }
  return d;
}, sd = (a, b, c) => {
  c ??= 2147483647;
  if (4 > c) {
    return 0;
  }
  var d = b;
  c = d + c - 4;
  for (var e = 0; e < a.length; ++e) {
    var f = a.charCodeAt(e);
    if (55296 <= f && 57343 >= f) {
      var g = a.charCodeAt(++e);
      f = 65536 + ((f & 1023) << 10) | g & 1023;
    }
    x[b >> 2] = f;
    b += 4;
    if (b + 4 > c) {
      break;
    }
  }
  x[b >> 2] = 0;
  return b - d;
}, td = a => {
  for (var b = 0, c = 0; c < a.length; ++c) {
    var d = a.charCodeAt(c);
    55296 <= d && 57343 >= d && ++c;
    b += 4;
  }
  return b;
}, ud = (a, b, c) => {
  var d = [];
  a = a.toWireType(d, c);
  d.length && (A[b >> 2] = hc(d));
  return a;
}, vd = {}, wd = a => {
  var b = vd[a];
  return void 0 === b ? I(a) : b;
}, xd = [], yd = a => {
  var b = xd.length;
  xd.push(a);
  return b;
}, zd = (a, b) => {
  for (var c = Array(a), d = 0; d < a; ++d) {
    c[d] = uc(A[b + 4 * d >> 2], "parameter " + d);
  }
  return c;
}, Ad = Reflect.construct, Bd = [], Cd = a => {
  var b = a.getExtension("ANGLE_instanced_arrays");
  b && (a.vertexAttribDivisor = (c, d) => b.vertexAttribDivisorANGLE(c, d), a.drawArraysInstanced = (c, d, e, f) => b.drawArraysInstancedANGLE(c, d, e, f), a.drawElementsInstanced = (c, d, e, f, g) => b.drawElementsInstancedANGLE(c, d, e, f, g));
}, Dd = a => {
  var b = a.getExtension("OES_vertex_array_object");
  b && (a.createVertexArray = () => b.createVertexArrayOES(), a.deleteVertexArray = c => b.deleteVertexArrayOES(c), a.bindVertexArray = c => b.bindVertexArrayOES(c), a.isVertexArray = c => b.isVertexArrayOES(c));
}, Ed = a => {
  var b = a.getExtension("WEBGL_draw_buffers");
  b && (a.drawBuffers = (c, d) => b.drawBuffersWEBGL(c, d));
}, Fd = a => {
  var b = "ANGLE_instanced_arrays EXT_blend_minmax EXT_disjoint_timer_query EXT_frag_depth EXT_shader_texture_lod EXT_sRGB OES_element_index_uint OES_fbo_render_mipmap OES_standard_derivatives OES_texture_float OES_texture_half_float OES_texture_half_float_linear OES_vertex_array_object WEBGL_color_buffer_float WEBGL_depth_texture WEBGL_draw_buffers EXT_color_buffer_float EXT_conservative_depth EXT_disjoint_timer_query_webgl2 EXT_texture_norm16 NV_shader_noperspective_interpolation WEBGL_clip_cull_distance EXT_color_buffer_half_float EXT_depth_clamp EXT_float_blend EXT_texture_compression_bptc EXT_texture_compression_rgtc EXT_texture_filter_anisotropic KHR_parallel_shader_compile OES_texture_float_linear WEBGL_blend_func_extended WEBGL_compressed_texture_astc WEBGL_compressed_texture_etc WEBGL_compressed_texture_etc1 WEBGL_compressed_texture_s3tc WEBGL_compressed_texture_s3tc_srgb WEBGL_debug_renderer_info WEBGL_debug_shaders WEBGL_lose_context WEBGL_multi_draw".split(" ");
  return (a.getSupportedExtensions() || []).filter(c => b.includes(c));
}, Gd = 1, Hd = [], Q = [], Id = [], Jd = [], Kd = [], Ld = [], Md = [], ma = [], Nd = [], Od = [], Pd = {}, Qd = {}, Rd = 4, Sd = 0, la = a => {
  for (var b = Gd++, c = a.length; c < b; c++) {
    a[c] = null;
  }
  return b;
}, Td = (a, b, c, d) => {
  for (var e = 0; e < a; e++) {
    var f = R[c](), g = f && la(d);
    f ? (f.name = g, d[g] = f) : S ||= 1282;
    x[b + 4 * e >> 2] = g;
  }
}, oa = a => {
  T = ma[a];
  l.sc = R = T?.Sa;
  return !(a && !R);
}, na = a => {
  a ||= T;
  if (!a.Pb) {
    a.Pb = !0;
    var b = a.Sa;
    Cd(b);
    Dd(b);
    Ed(b);
    b.Ya = b.getExtension("WEBGL_draw_instanced_base_vertex_base_instance");
    b.fb = b.getExtension("WEBGL_multi_draw_instanced_base_vertex_base_instance");
    2 <= a.version && (b.Za = b.getExtension("EXT_disjoint_timer_query_webgl2"));
    if (2 > a.version || !b.Za) {
      b.Za = b.getExtension("EXT_disjoint_timer_query");
    }
    b.Bc = b.getExtension("WEBGL_multi_draw");
    Fd(b).forEach(c => {
      c.includes("lose_context") || c.includes("debug") || b.getExtension(c);
    });
  }
}, S, T, Ud = (a, b) => {
  R.bindFramebuffer(a, Id[b]);
}, Vd = a => {
  R.bindVertexArray(Md[a]);
}, Wd = (a, b) => {
  for (var c = 0; c < a; c++) {
    var d = x[b + 4 * c >> 2];
    R.deleteVertexArray(Md[d]);
    Md[d] = null;
  }
}, Xd = [], Yd = (a, b) => {
  Td(a, b, "createVertexArray", Md);
};
function Zd() {
  var a = Fd(R);
  return a = a.concat(a.map(b => "GL_" + b));
}
var $d = (a, b) => {
  if (b) {
    var c = void 0;
    switch(a) {
      case 36346:
        c = 1;
        break;
      case 36344:
        return;
      case 34814:
      case 36345:
        c = 0;
        break;
      case 34466:
        var d = R.getParameter(34467);
        c = d ? d.length : 0;
        break;
      case 33309:
        if (2 > T.version) {
          S ||= 1282;
          return;
        }
        c = Zd().length;
        break;
      case 33307:
      case 33308:
        if (2 > T.version) {
          S ||= 1280;
          return;
        }
        c = 33307 == a ? 3 : 0;
    }
    if (void 0 === c) {
      switch(d = R.getParameter(a), typeof d) {
        case "number":
          c = d;
          break;
        case "boolean":
          c = d ? 1 : 0;
          break;
        case "string":
          S ||= 1280;
          return;
        case "object":
          if (null === d) {
            switch(a) {
              case 34964:
              case 35725:
              case 34965:
              case 36006:
              case 36007:
              case 32873:
              case 34229:
              case 36662:
              case 36663:
              case 35053:
              case 35055:
              case 36010:
              case 35097:
              case 35869:
              case 32874:
              case 36389:
              case 35983:
              case 35368:
              case 34068:
                c = 0;
                break;
              default:
                S ||= 1280;
                return;
            }
          } else {
            if (d instanceof Float32Array || d instanceof Uint32Array || d instanceof Int32Array || d instanceof Array) {
              for (a = 0; a < d.length; ++a) {
                x[b + 4 * a >> 2] = d[a];
              }
              return;
            }
            try {
              c = d.name | 0;
            } catch (e) {
              S ||= 1280;
              wa(`GL_INVALID_ENUM in glGet${0}v: Unknown object returned from WebGL getParameter(${a})! (error: ${e})`);
              return;
            }
          }
          break;
        default:
          S ||= 1280;
          wa(`GL_INVALID_ENUM in glGet${0}v: Native code calling glGet${0}v(${a}) and it returns ${d} of type ${typeof d}!`);
          return;
      }
    }
    x[b >> 2] = c;
  } else {
    S ||= 1281;
  }
}, ae = (a, b) => $d(a, b), ce = a => {
  var b = jb(a) + 1, c = be(b);
  c && kb(a, v, c, b);
  return c;
}, de = a => "]" == a.slice(-1) && a.lastIndexOf("["), ee = a => {
  a -= 5120;
  return 0 == a ? n : 1 == a ? v : 2 == a ? Aa : 4 == a ? x : 6 == a ? B : 5 == a || 28922 == a || 28520 == a || 30779 == a || 30782 == a ? A : Ba;
}, fe = (a, b, c, d, e) => {
  a = ee(a);
  b = d * ((Sd || c) * ({5:3, 6:4, 8:2, 29502:3, 29504:4, 26917:2, 26918:2, 29846:3, 29847:4}[b - 6402] || 1) * a.BYTES_PER_ELEMENT + Rd - 1 & -Rd);
  return a.subarray(e >>> 31 - Math.clz32(a.BYTES_PER_ELEMENT), e + b >>> 31 - Math.clz32(a.BYTES_PER_ELEMENT));
}, U = a => {
  var b = R.Db;
  if (b) {
    var c = b.la[a];
    "number" == typeof c && (b.la[a] = c = R.getUniformLocation(b, b.rb[a] + (0 < c ? `[${c}]` : "")));
    return c;
  }
  S ||= 1282;
}, ge = [], he = [], ie = {}, ke = () => {
  if (!je) {
    var a = {USER:"web_user", LOGNAME:"web_user", PATH:"/", PWD:"/", HOME:"/home/web_user", LANG:("object" == typeof navigator && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8", _:qa || "./this.program"}, b;
    for (b in ie) {
      void 0 === ie[b] ? delete a[b] : a[b] = ie[b];
    }
    var c = [];
    for (b in a) {
      c.push(`${b}=${a[b]}`);
    }
    je = c;
  }
  return je;
}, je, le = a => 0 === a % 4 && (0 !== a % 100 || 0 === a % 400), me = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], ne = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], oe = (a, b, c, d) => {
  function e(q, t, u) {
    for (q = "number" == typeof q ? q.toString() : q || ""; q.length < t;) {
      q = u[0] + q;
    }
    return q;
  }
  function f(q, t) {
    return e(q, t, "0");
  }
  function g(q, t) {
    function u(C) {
      return 0 > C ? -1 : 0 < C ? 1 : 0;
    }
    var z;
    0 === (z = u(q.getFullYear() - t.getFullYear())) && 0 === (z = u(q.getMonth() - t.getMonth())) && (z = u(q.getDate() - t.getDate()));
    return z;
  }
  function k(q) {
    switch(q.getDay()) {
      case 0:
        return new Date(q.getFullYear() - 1, 11, 29);
      case 1:
        return q;
      case 2:
        return new Date(q.getFullYear(), 0, 3);
      case 3:
        return new Date(q.getFullYear(), 0, 2);
      case 4:
        return new Date(q.getFullYear(), 0, 1);
      case 5:
        return new Date(q.getFullYear() - 1, 11, 31);
      case 6:
        return new Date(q.getFullYear() - 1, 11, 30);
    }
  }
  function m(q) {
    var t = q.$;
    for (q = new Date((new Date(q.aa + 1900, 0, 1)).getTime()); 0 < t;) {
      var u = q.getMonth(), z = (le(q.getFullYear()) ? me : ne)[u];
      if (t > z - q.getDate()) {
        t -= z - q.getDate() + 1, q.setDate(1), 11 > u ? q.setMonth(u + 1) : (q.setMonth(0), q.setFullYear(q.getFullYear() + 1));
      } else {
        q.setDate(q.getDate() + t);
        break;
      }
    }
    u = new Date(q.getFullYear() + 1, 0, 4);
    t = k(new Date(q.getFullYear(), 0, 4));
    u = k(u);
    return 0 >= g(t, q) ? 0 >= g(u, q) ? q.getFullYear() + 1 : q.getFullYear() : q.getFullYear() - 1;
  }
  var p = A[d + 40 >> 2];
  d = {dc:x[d >> 2], cc:x[d + 4 >> 2], Fa:x[d + 8 >> 2], Pa:x[d + 12 >> 2], Ga:x[d + 16 >> 2], aa:x[d + 20 >> 2], P:x[d + 24 >> 2], $:x[d + 28 >> 2], Fc:x[d + 32 >> 2], bc:x[d + 36 >> 2], ec:p ? p ? D(v, p) : "" : ""};
  c = c ? D(v, c) : "";
  p = {"%c":"%a %b %d %H:%M:%S %Y", "%D":"%m/%d/%y", "%F":"%Y-%m-%d", "%h":"%b", "%r":"%I:%M:%S %p", "%R":"%H:%M", "%T":"%H:%M:%S", "%x":"%m/%d/%y", "%X":"%H:%M:%S", "%Ec":"%c", "%EC":"%C", "%Ex":"%m/%d/%y", "%EX":"%H:%M:%S", "%Ey":"%y", "%EY":"%Y", "%Od":"%d", "%Oe":"%e", "%OH":"%H", "%OI":"%I", "%Om":"%m", "%OM":"%M", "%OS":"%S", "%Ou":"%u", "%OU":"%U", "%OV":"%V", "%Ow":"%w", "%OW":"%W", "%Oy":"%y",};
  for (var r in p) {
    c = c.replace(new RegExp(r, "g"), p[r]);
  }
  var w = "Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "), y = "January February March April May June July August September October November December".split(" ");
  p = {"%a":q => w[q.P].substring(0, 3), "%A":q => w[q.P], "%b":q => y[q.Ga].substring(0, 3), "%B":q => y[q.Ga], "%C":q => f((q.aa + 1900) / 100 | 0, 2), "%d":q => f(q.Pa, 2), "%e":q => e(q.Pa, 2, " "), "%g":q => m(q).toString().substring(2), "%G":m, "%H":q => f(q.Fa, 2), "%I":q => {
    q = q.Fa;
    0 == q ? q = 12 : 12 < q && (q -= 12);
    return f(q, 2);
  }, "%j":q => {
    for (var t = 0, u = 0; u <= q.Ga - 1; t += (le(q.aa + 1900) ? me : ne)[u++]) {
    }
    return f(q.Pa + t, 3);
  }, "%m":q => f(q.Ga + 1, 2), "%M":q => f(q.cc, 2), "%n":() => "\n", "%p":q => 0 <= q.Fa && 12 > q.Fa ? "AM" : "PM", "%S":q => f(q.dc, 2), "%t":() => "\t", "%u":q => q.P || 7, "%U":q => f(Math.floor((q.$ + 7 - q.P) / 7), 2), "%V":q => {
    var t = Math.floor((q.$ + 7 - (q.P + 6) % 7) / 7);
    2 >= (q.P + 371 - q.$ - 2) % 7 && t++;
    if (t) {
      53 == t && (u = (q.P + 371 - q.$) % 7, 4 == u || 3 == u && le(q.aa) || (t = 1));
    } else {
      t = 52;
      var u = (q.P + 7 - q.$ - 1) % 7;
      (4 == u || 5 == u && le(q.aa % 400 - 1)) && t++;
    }
    return f(t, 2);
  }, "%w":q => q.P, "%W":q => f(Math.floor((q.$ + 7 - (q.P + 6) % 7) / 7), 2), "%y":q => (q.aa + 1900).toString().substring(2), "%Y":q => q.aa + 1900, "%z":q => {
    q = q.bc;
    var t = 0 <= q;
    q = Math.abs(q) / 60;
    return (t ? "+" : "-") + String("0000" + (q / 60 * 100 + q % 60)).slice(-4);
  }, "%Z":q => q.ec, "%%":() => "%"};
  c = c.replace(/%%/g, "\x00\x00");
  for (r in p) {
    c.includes(r) && (c = c.replace(new RegExp(r, "g"), p[r](d)));
  }
  c = c.replace(/\0\0/g, "%");
  r = lb(c, !1);
  if (r.length > b) {
    return 0;
  }
  n.set(r, a);
  return r.length - 1;
};
[44].forEach(a => {
  vb[a] = new F(a);
  vb[a].stack = "<generic error, no stack>";
});
Eb = Array(4096);
Sb(G, "/");
Ub("/tmp");
Ub("/home");
Ub("/home/web_user");
(function() {
  Ub("/dev");
  ob(259, {read:() => 0, write:(d, e, f, g) => g,});
  Vb("/dev/null", 259);
  nb(1280, qb);
  nb(1536, rb);
  Vb("/dev/tty", 1280);
  Vb("/dev/tty1", 1536);
  var a = new Uint8Array(1024), b = 0, c = () => {
    0 === b && (b = fb(a).byteLength);
    return a[--b];
  };
  ac("random", c);
  ac("urandom", c);
  Ub("/dev/shm");
  Ub("/dev/shm/tmp");
})();
(function() {
  Ub("/proc");
  var a = Ub("/proc/self");
  Ub("/proc/self/fd");
  Sb({S() {
    var b = ub(a, "fd", 16895, 73);
    b.j = {ja(c, d) {
      var e = Pb(+d);
      c = {parent:null, S:{hb:"fake"}, j:{ka:() => e.path},};
      return c.parent = c;
    }};
    return b;
  }}, "/proc/self/fd");
})();
H = l.BindingError = class extends Error {
  constructor(a) {
    super(a);
    this.name = "BindingError";
  }
};
fc.push(0, 1, void 0, 1, null, 1, !0, 1, !1, 1,);
l.count_emval_handles = () => fc.length / 2 - 5 - ec.length;
jc = l.PureVirtualError = ic("PureVirtualError");
for (var pe = Array(256), qe = 0; 256 > qe; ++qe) {
  pe[qe] = String.fromCharCode(qe);
}
kc = pe;
l.getInheritedInstanceCount = () => Object.keys(oc).length;
l.getLiveInheritedInstances = () => {
  var a = [], b;
  for (b in oc) {
    oc.hasOwnProperty(b) && a.push(oc[b]);
  }
  return a;
};
l.flushPendingDeletes = mc;
l.setDelayFunction = a => {
  nc = a;
  lc.length && nc && nc(mc);
};
Ac = l.InternalError = class extends Error {
  constructor(a) {
    super(a);
    this.name = "InternalError";
  }
};
Object.assign(Lc.prototype, {isAliasOf:function(a) {
  if (!(this instanceof Lc && a instanceof Lc)) {
    return !1;
  }
  var b = this.g.u.i, c = this.g.o;
  a.g = a.g;
  var d = a.g.u.i;
  for (a = a.g.o; b.B;) {
    c = b.ma(c), b = b.B;
  }
  for (; d.B;) {
    a = d.ma(a), d = d.B;
  }
  return b === d && c === a;
}, clone:function() {
  this.g.o || Kc(this);
  if (this.g.ha) {
    return this.g.count.value += 1, this;
  }
  var a = Bc, b = Object, c = b.create, d = Object.getPrototypeOf(this), e = this.g;
  a = a(c.call(b, d, {g:{value:{count:e.count, fa:e.fa, ha:e.ha, o:e.o, u:e.u, D:e.D, I:e.I,},}}));
  a.g.count.value += 1;
  a.g.fa = !1;
  return a;
}, ["delete"]() {
  this.g.o || Kc(this);
  if (this.g.fa && !this.g.ha) {
    throw new H("Object already scheduled for deletion");
  }
  vc(this);
  var a = this.g;
  --a.count.value;
  0 === a.count.value && (a.D ? a.I.N(a.D) : a.u.i.N(a.o));
  this.g.ha || (this.g.D = void 0, this.g.o = void 0);
}, isDeleted:function() {
  return !this.g.o;
}, deleteLater:function() {
  this.g.o || Kc(this);
  if (this.g.fa && !this.g.ha) {
    throw new H("Object already scheduled for deletion");
  }
  lc.push(this);
  1 === lc.length && nc && nc(mc);
  this.g.fa = !0;
  return this;
},});
Object.assign(Vc.prototype, {Kb(a) {
  this.mb && (a = this.mb(a));
  return a;
}, Xa(a) {
  this.N?.(a);
}, argPackAdvance:8, readValueFromPointer:Fc, fromWireType:function(a) {
  function b() {
    return this.ua ? Cc(this.i.L, {u:this.Wb, o:c, I:this, D:a,}) : Cc(this.i.L, {u:this, o:a,});
  }
  var c = this.Kb(a);
  if (!c) {
    return this.Xa(a), null;
  }
  var d = zc(this.i, c);
  if (void 0 !== d) {
    if (0 === d.g.count.value) {
      return d.g.o = c, d.g.D = a, d.clone();
    }
    d = d.clone();
    this.Xa(a);
    return d;
  }
  d = this.i.Jb(c);
  d = yc[d];
  if (!d) {
    return b.call(this);
  }
  d = this.ta ? d.Cb : d.pointerType;
  var e = xc(c, this.i, d.i);
  return null === e ? b.call(this) : this.ua ? Cc(d.i.L, {u:d, o:e, I:this, D:a,}) : Cc(d.i.L, {u:d, o:e,});
},});
ad = l.UnboundTypeError = ic("UnboundTypeError");
for (var R, V = 0; 32 > V; ++V) {
  Xd.push(Array(V));
}
var re = new Float32Array(288);
for (V = 0; 288 > V; ++V) {
  ge[V] = re.subarray(0, V);
}
var se = new Int32Array(288);
for (V = 0; 288 > V; ++V) {
  he[V] = se.subarray(0, V);
}
var Ie = {__syscall_fcntl64:function(a, b, c) {
  $a = c;
  try {
    var d = Pb(a);
    switch(b) {
      case 0:
        var e = Za();
        if (0 > e) {
          break;
        }
        for (; Cb[e];) {
          e++;
        }
        return Rb(d, e).U;
      case 1:
      case 2:
        return 0;
      case 3:
        return d.flags;
      case 4:
        return e = Za(), d.flags |= e, 0;
      case 12:
        return e = Za(), Aa[e + 0 >> 1] = 2, 0;
      case 13:
      case 14:
        return 0;
    }
    return -28;
  } catch (f) {
    if ("undefined" == typeof cc || "ErrnoError" !== f.name) {
      throw f;
    }
    return -f.Y;
  }
}, __syscall_ioctl:function(a, b, c) {
  $a = c;
  try {
    var d = Pb(a);
    switch(b) {
      case 21509:
        return d.s ? 0 : -59;
      case 21505:
        if (!d.s) {
          return -59;
        }
        if (d.s.T.Rb) {
          a = [3, 28, 127, 21, 4, 0, 1, 0, 17, 19, 26, 0, 18, 15, 23, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,];
          var e = Za();
          x[e >> 2] = 25856;
          x[e + 4 >> 2] = 5;
          x[e + 8 >> 2] = 191;
          x[e + 12 >> 2] = 35387;
          for (var f = 0; 32 > f; f++) {
            n[e + f + 17] = a[f] || 0;
          }
        }
        return 0;
      case 21510:
      case 21511:
      case 21512:
        return d.s ? 0 : -59;
      case 21506:
      case 21507:
      case 21508:
        if (!d.s) {
          return -59;
        }
        if (d.s.T.Sb) {
          for (e = Za(), a = [], f = 0; 32 > f; f++) {
            a.push(n[e + f + 17]);
          }
        }
        return 0;
      case 21519:
        if (!d.s) {
          return -59;
        }
        e = Za();
        return x[e >> 2] = 0;
      case 21520:
        return d.s ? -28 : -59;
      case 21531:
        e = Za();
        if (!d.m.Qb) {
          throw new F(59);
        }
        return d.m.Qb(d, b, e);
      case 21523:
        if (!d.s) {
          return -59;
        }
        d.s.T.Tb && (f = [24, 80], e = Za(), Aa[e >> 1] = f[0], Aa[e + 2 >> 1] = f[1]);
        return 0;
      case 21524:
        return d.s ? 0 : -59;
      case 21515:
        return d.s ? 0 : -59;
      default:
        return -28;
    }
  } catch (g) {
    if ("undefined" == typeof cc || "ErrnoError" !== g.name) {
      throw g;
    }
    return -g.Y;
  }
}, __syscall_openat:function(a, b, c, d) {
  $a = d;
  try {
    b = b ? D(v, b) : "";
    var e = b;
    if ("/" === e.charAt(0)) {
      b = e;
    } else {
      var f = -100 === a ? "/" : Pb(a).path;
      if (0 == e.length) {
        throw new F(44);
      }
      b = bb(f + "/" + e);
    }
    var g = d ? Za() : 0;
    return Xb(b, c, g).U;
  } catch (k) {
    if ("undefined" == typeof cc || "ErrnoError" !== k.name) {
      throw k;
    }
    return -k.Y;
  }
}, _abort_js:() => {
  La("");
}, _embind_create_inheriting_constructor:(a, b, c) => {
  a = I(a);
  b = uc(b, "wrapper");
  c = gc(c);
  var d = b.i, e = d.L, f = d.B.L, g = d.B.constructor;
  a = dc(a, function(...k) {
    d.B.lb.forEach(function(m) {
      if (this[m] === f[m]) {
        throw new jc(`Pure virtual function ${m} must be implemented in JavaScript`);
      }
    }.bind(this));
    Object.defineProperty(this, "__parent", {value:e});
    this.__construct(...k);
  });
  e.__construct = function(...k) {
    if (this === e) {
      throw new H("Pass correct 'this' to __construct");
    }
    k = g.implement(this, ...k);
    vc(k);
    var m = k.g;
    k.notifyOnDestruction();
    m.ha = !0;
    Object.defineProperties(this, {g:{value:m}});
    Bc(this);
    k = m.o;
    k = pc(d, k);
    if (oc.hasOwnProperty(k)) {
      throw new H(`Tried to register registered instance: ${k}`);
    }
    oc[k] = this;
  };
  e.__destruct = function() {
    if (this === e) {
      throw new H("Pass correct 'this' to __destruct");
    }
    vc(this);
    var k = this.g.o;
    k = pc(d, k);
    if (oc.hasOwnProperty(k)) {
      delete oc[k];
    } else {
      throw new H(`Tried to unregister unregistered instance: ${k}`);
    }
  };
  a.prototype = Object.create(e);
  Object.assign(a.prototype, c);
  return hc(a);
}, _embind_finalize_value_object:a => {
  var b = Dc[a];
  delete Dc[a];
  var c = b.Na, d = b.N, e = b.$a, f = e.map(g => g.Nb).concat(e.map(g => g.Zb));
  J([a], f, g => {
    var k = {};
    e.forEach((m, p) => {
      var r = g[p], w = m.Lb, y = m.Mb, q = g[p + e.length], t = m.Yb, u = m.$b;
      k[m.Hb] = {read:z => r.fromWireType(w(y, z)), write:(z, C) => {
        var E = [];
        t(u, z, q.toWireType(E, C));
        Ec(E);
      }};
    });
    return [{name:b.name, fromWireType:m => {
      var p = {}, r;
      for (r in k) {
        p[r] = k[r].read(m);
      }
      d(m);
      return p;
    }, toWireType:(m, p) => {
      for (var r in k) {
        if (!(r in p)) {
          throw new TypeError(`Missing field: "${r}"`);
        }
      }
      var w = c();
      for (r in k) {
        k[r].write(w, p[r]);
      }
      null !== m && m.push(d, w);
      return w;
    }, argPackAdvance:8, readValueFromPointer:Fc, K:d,}];
  });
}, _embind_register_bigint:() => {
}, _embind_register_bool:(a, b, c, d) => {
  b = I(b);
  Ic(a, {name:b, fromWireType:function(e) {
    return !!e;
  }, toWireType:function(e, f) {
    return f ? c : d;
  }, argPackAdvance:8, readValueFromPointer:function(e) {
    return this.fromWireType(v[e]);
  }, K:null,});
}, _embind_register_class:(a, b, c, d, e, f, g, k, m, p, r, w, y) => {
  r = I(r);
  f = P(e, f);
  k &&= P(g, k);
  p &&= P(m, p);
  y = P(w, y);
  var q = Oc(r);
  Nc(q, function() {
    bd(`Cannot construct ${r} due to unbound types`, [d]);
  });
  J([a, b, c], d ? [d] : [], t => {
    t = t[0];
    if (d) {
      var u = t.i;
      var z = u.L;
    } else {
      z = Lc.prototype;
    }
    t = dc(r, function(...N) {
      if (Object.getPrototypeOf(this) !== C) {
        throw new H("Use 'new' to construct " + r);
      }
      if (void 0 === E.X) {
        throw new H(r + " has no accessible constructor");
      }
      var O = E.X[N.length];
      if (void 0 === O) {
        throw new H(`Tried to invoke ctor of ${r} with invalid number of parameters (${N.length}) - expected (${Object.keys(E.X).toString()}) parameters instead!`);
      }
      return O.apply(this, N);
    });
    var C = Object.create(z, {constructor:{value:t},});
    t.prototype = C;
    var E = new Pc(r, t, C, y, u, f, k, p);
    if (E.B) {
      var M;
      (M = E.B).na ?? (M.na = []);
      E.B.na.push(E);
    }
    u = new Vc(r, E, !0, !1, !1);
    M = new Vc(r + "*", E, !1, !1, !1);
    z = new Vc(r + " const*", E, !1, !0, !1);
    yc[a] = {pointerType:M, Cb:z};
    Wc(q, t);
    return [u, M, z];
  });
}, _embind_register_class_class_function:(a, b, c, d, e, f, g) => {
  var k = ed(c, d);
  b = I(b);
  b = fd(b);
  f = P(e, f);
  J([], [a], m => {
    function p() {
      bd(`Cannot call ${r} due to unbound types`, k);
    }
    m = m[0];
    var r = `${m.name}.${b}`;
    b.startsWith("@@") && (b = Symbol[b.substring(2)]);
    var w = m.i.constructor;
    void 0 === w[b] ? (p.da = c - 1, w[b] = p) : (Mc(w, b, r), w[b].A[c - 1] = p);
    J([], k, y => {
      y = dd(r, [y[0], null].concat(y.slice(1)), null, f, g);
      void 0 === w[b].A ? (y.da = c - 1, w[b] = y) : w[b].A[c - 1] = y;
      if (m.i.na) {
        for (const q of m.i.na) {
          q.constructor.hasOwnProperty(b) || (q.constructor[b] = y);
        }
      }
      return [];
    });
    return [];
  });
}, _embind_register_class_class_property:(a, b, c, d, e, f, g, k) => {
  b = I(b);
  f = P(e, f);
  J([], [a], m => {
    m = m[0];
    var p = `${m.name}.${b}`, r = {get() {
      bd(`Cannot access ${p} due to unbound types`, [c]);
    }, enumerable:!0, configurable:!0};
    r.set = k ? () => {
      bd(`Cannot access ${p} due to unbound types`, [c]);
    } : () => {
      throw new H(`${p} is a read-only property`);
    };
    Object.defineProperty(m.i.constructor, b, r);
    J([], [c], w => {
      w = w[0];
      var y = {get() {
        return w.fromWireType(f(d));
      }, enumerable:!0};
      k && (k = P(g, k), y.set = q => {
        var t = [];
        k(d, w.toWireType(t, q));
        Ec(t);
      });
      Object.defineProperty(m.i.constructor, b, y);
      return [];
    });
    return [];
  });
}, _embind_register_class_constructor:(a, b, c, d, e, f) => {
  var g = ed(b, c);
  e = P(d, e);
  J([], [a], k => {
    k = k[0];
    var m = `constructor ${k.name}`;
    void 0 === k.i.X && (k.i.X = []);
    if (void 0 !== k.i.X[b - 1]) {
      throw new H(`Cannot register multiple constructors with identical number of parameters (${b - 1}) for class '${k.name}'! Overload resolution is currently only performed using the parameter count, not actual type info!`);
    }
    k.i.X[b - 1] = () => {
      bd(`Cannot construct ${k.name} due to unbound types`, g);
    };
    J([], g, p => {
      p.splice(1, 0, null);
      k.i.X[b - 1] = dd(m, p, null, e, f);
      return [];
    });
    return [];
  });
}, _embind_register_class_function:(a, b, c, d, e, f, g, k) => {
  var m = ed(c, d);
  b = I(b);
  b = fd(b);
  f = P(e, f);
  J([], [a], p => {
    function r() {
      bd(`Cannot call ${w} due to unbound types`, m);
    }
    p = p[0];
    var w = `${p.name}.${b}`;
    b.startsWith("@@") && (b = Symbol[b.substring(2)]);
    k && p.i.lb.push(b);
    var y = p.i.L, q = y[b];
    void 0 === q || void 0 === q.A && q.className !== p.name && q.da === c - 2 ? (r.da = c - 2, r.className = p.name, y[b] = r) : (Mc(y, b, w), y[b].A[c - 2] = r);
    J([], m, t => {
      t = dd(w, t, p, f, g);
      void 0 === y[b].A ? (t.da = c - 2, y[b] = t) : y[b].A[c - 2] = t;
      return [];
    });
    return [];
  });
}, _embind_register_class_property:(a, b, c, d, e, f, g, k, m, p) => {
  b = I(b);
  e = P(d, e);
  J([], [a], r => {
    r = r[0];
    var w = `${r.name}.${b}`, y = {get() {
      bd(`Cannot access ${w} due to unbound types`, [c, g]);
    }, enumerable:!0, configurable:!0};
    y.set = m ? () => bd(`Cannot access ${w} due to unbound types`, [c, g]) : () => {
      throw new H(w + " is a read-only property");
    };
    Object.defineProperty(r.i.L, b, y);
    J([], m ? [c, g] : [c], q => {
      var t = q[0], u = {get() {
        var C = gd(this, r, w + " getter");
        return t.fromWireType(e(f, C));
      }, enumerable:!0};
      if (m) {
        m = P(k, m);
        var z = q[1];
        u.set = function(C) {
          var E = gd(this, r, w + " setter"), M = [];
          m(p, E, z.toWireType(M, C));
          Ec(M);
        };
      }
      Object.defineProperty(r.i.L, b, u);
      return [];
    });
    return [];
  });
}, _embind_register_emval:a => Ic(a, jd), _embind_register_enum:(a, b, c, d) => {
  function e() {
  }
  b = I(b);
  e.values = {};
  Ic(a, {name:b, constructor:e, fromWireType:function(f) {
    return this.constructor.values[f];
  }, toWireType:(f, g) => g.value, argPackAdvance:8, readValueFromPointer:kd(b, c, d), K:null,});
  Nc(b, e);
}, _embind_register_enum_value:(a, b, c) => {
  var d = uc(a, "enum");
  b = I(b);
  a = d.constructor;
  d = Object.create(d.constructor.prototype, {value:{value:c}, constructor:{value:dc(`${d.name}_${b}`, function() {
  })},});
  a.values[c] = d;
  a[b] = d;
}, _embind_register_float:(a, b, c) => {
  b = I(b);
  Ic(a, {name:b, fromWireType:d => d, toWireType:(d, e) => e, argPackAdvance:8, readValueFromPointer:ld(b, c), K:null,});
}, _embind_register_function:(a, b, c, d, e, f) => {
  var g = ed(b, c);
  a = I(a);
  a = fd(a);
  e = P(d, e);
  Nc(a, function() {
    bd(`Cannot call ${a} due to unbound types`, g);
  }, b - 1);
  J([], g, k => {
    Wc(a, dd(a, [k[0], null].concat(k.slice(1)), null, e, f), b - 1);
    return [];
  });
}, _embind_register_integer:(a, b, c, d, e) => {
  b = I(b);
  -1 === e && (e = 4294967295);
  e = k => k;
  if (0 === d) {
    var f = 32 - 8 * c;
    e = k => k << f >>> f;
  }
  var g = b.includes("unsigned") ? function(k, m) {
    return m >>> 0;
  } : function(k, m) {
    return m;
  };
  Ic(a, {name:b, fromWireType:e, toWireType:g, argPackAdvance:8, readValueFromPointer:md(b, c, 0 !== d), K:null,});
}, _embind_register_memory_view:(a, b, c) => {
  function d(f) {
    return new e(n.buffer, A[f + 4 >> 2], A[f >> 2]);
  }
  var e = [Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array,][b];
  c = I(c);
  Ic(a, {name:c, fromWireType:d, argPackAdvance:8, readValueFromPointer:d,}, {Ob:!0,});
}, _embind_register_std_string:(a, b) => {
  b = I(b);
  var c = "std::string" === b;
  Ic(a, {name:b, fromWireType:function(d) {
    var e = A[d >> 2], f = d + 4;
    if (c) {
      for (var g = f, k = 0; k <= e; ++k) {
        var m = f + k;
        if (k == e || 0 == v[m]) {
          g = g ? D(v, g, m - g) : "";
          if (void 0 === p) {
            var p = g;
          } else {
            p += String.fromCharCode(0), p += g;
          }
          g = m + 1;
        }
      }
    } else {
      p = Array(e);
      for (k = 0; k < e; ++k) {
        p[k] = String.fromCharCode(v[f + k]);
      }
      p = p.join("");
    }
    sc(d);
    return p;
  }, toWireType:function(d, e) {
    e instanceof ArrayBuffer && (e = new Uint8Array(e));
    var f = "string" == typeof e;
    if (!(f || e instanceof Uint8Array || e instanceof Uint8ClampedArray || e instanceof Int8Array)) {
      throw new H("Cannot pass non-string to std::string");
    }
    var g = c && f ? jb(e) : e.length;
    var k = be(4 + g + 1), m = k + 4;
    A[k >> 2] = g;
    if (c && f) {
      kb(e, v, m, g + 1);
    } else {
      if (f) {
        for (f = 0; f < g; ++f) {
          var p = e.charCodeAt(f);
          if (255 < p) {
            throw sc(m), new H("String has UTF-16 code units that do not fit in 8 bits");
          }
          v[m + f] = p;
        }
      } else {
        for (f = 0; f < g; ++f) {
          v[m + f] = e[f];
        }
      }
    }
    null !== d && d.push(sc, k);
    return k;
  }, argPackAdvance:8, readValueFromPointer:Fc, K(d) {
    sc(d);
  },});
}, _embind_register_std_wstring:(a, b, c) => {
  c = I(c);
  if (2 === b) {
    var d = od;
    var e = pd;
    var f = qd;
    var g = k => Ba[k >> 1];
  } else {
    4 === b && (d = rd, e = sd, f = td, g = k => A[k >> 2]);
  }
  Ic(a, {name:c, fromWireType:k => {
    for (var m = A[k >> 2], p, r = k + 4, w = 0; w <= m; ++w) {
      var y = k + 4 + w * b;
      if (w == m || 0 == g(y)) {
        r = d(r, y - r), void 0 === p ? p = r : (p += String.fromCharCode(0), p += r), r = y + b;
      }
    }
    sc(k);
    return p;
  }, toWireType:(k, m) => {
    if ("string" != typeof m) {
      throw new H(`Cannot pass non-string to C++ string type ${c}`);
    }
    var p = f(m), r = be(4 + p + b);
    A[r >> 2] = p / b;
    e(m, r + 4, p + b);
    null !== k && k.push(sc, r);
    return r;
  }, argPackAdvance:8, readValueFromPointer:Fc, K(k) {
    sc(k);
  }});
}, _embind_register_value_object:(a, b, c, d, e, f) => {
  Dc[a] = {name:I(b), Na:P(c, d), N:P(e, f), $a:[],};
}, _embind_register_value_object_field:(a, b, c, d, e, f, g, k, m, p) => {
  Dc[a].$a.push({Hb:I(b), Nb:c, Lb:P(d, e), Mb:f, Zb:g, Yb:P(k, m), $b:p,});
}, _embind_register_void:(a, b) => {
  b = I(b);
  Ic(a, {yc:!0, name:b, argPackAdvance:0, fromWireType:() => {
  }, toWireType:() => {
  },});
}, _emscripten_get_now_is_monotonic:() => 1, _emscripten_memcpy_js:(a, b, c) => v.copyWithin(a, b, b + c), _emscripten_throw_longjmp:() => {
  throw Infinity;
}, _emval_as:(a, b, c) => {
  a = gc(a);
  b = uc(b, "emval::as");
  return ud(b, c, a);
}, _emval_call_method:(a, b, c, d, e) => {
  a = xd[a];
  b = gc(b);
  c = wd(c);
  return a(b, b[c], d, e);
}, _emval_decref:hd, _emval_get_method_caller:(a, b, c) => {
  var d = zd(a, b), e = d.shift();
  a--;
  var f = Array(a);
  b = `methodCaller<(${d.map(g => g.name).join(", ")}) => ${e.name}>`;
  return yd(dc(b, (g, k, m, p) => {
    for (var r = 0, w = 0; w < a; ++w) {
      f[w] = d[w].readValueFromPointer(p + r), r += d[w].argPackAdvance;
    }
    g = 1 === c ? Ad(k, f) : k.apply(g, f);
    return ud(e, m, g);
  }));
}, _emval_get_property:(a, b) => {
  a = gc(a);
  b = gc(b);
  return hc(a[b]);
}, _emval_incref:a => {
  9 < a && (fc[a + 1] += 1);
}, _emval_new_array:() => hc([]), _emval_new_cstring:a => hc(wd(a)), _emval_new_object:() => hc({}), _emval_run_destructors:a => {
  var b = gc(a);
  Ec(b);
  hd(a);
}, _emval_set_property:(a, b, c) => {
  a = gc(a);
  b = gc(b);
  c = gc(c);
  a[b] = c;
}, _emval_take_value:(a, b) => {
  a = uc(a, "_emval_take_value");
  a = a.readValueFromPointer(b);
  return hc(a);
}, emscripten_asm_const_int:(a, b, c) => {
  Bd.length = 0;
  for (var d; d = v[b++];) {
    var e = 105 != d;
    e &= 112 != d;
    c += e && c % 8 ? 4 : 0;
    Bd.push(112 == d ? A[c >> 2] : 105 == d ? x[c >> 2] : Ca[c >> 3]);
    c += e ? 8 : 4;
  }
  return Xa[a](...Bd);
}, emscripten_date_now:() => Date.now(), emscripten_get_now:() => performance.now(), emscripten_glActiveTexture:a => R.activeTexture(a), emscripten_glAttachShader:(a, b) => {
  R.attachShader(Q[a], Ld[b]);
}, emscripten_glBindAttribLocation:(a, b, c) => {
  R.bindAttribLocation(Q[a], b, c ? D(v, c) : "");
}, emscripten_glBindBuffer:(a, b) => {
  35051 == a ? R.Ia = b : 35052 == a && (R.ea = b);
  R.bindBuffer(a, Hd[b]);
}, emscripten_glBindFramebuffer:Ud, emscripten_glBindRenderbuffer:(a, b) => {
  R.bindRenderbuffer(a, Jd[b]);
}, emscripten_glBindSampler:(a, b) => {
  R.bindSampler(a, Nd[b]);
}, emscripten_glBindTexture:(a, b) => {
  R.bindTexture(a, Kd[b]);
}, emscripten_glBindVertexArray:Vd, emscripten_glBindVertexArrayOES:Vd, emscripten_glBlendColor:(a, b, c, d) => R.blendColor(a, b, c, d), emscripten_glBlendEquation:a => R.blendEquation(a), emscripten_glBlendFunc:(a, b) => R.blendFunc(a, b), emscripten_glBlitFramebuffer:(a, b, c, d, e, f, g, k, m, p) => R.blitFramebuffer(a, b, c, d, e, f, g, k, m, p), emscripten_glBufferData:(a, b, c, d) => {
  2 <= T.version ? c && b ? R.bufferData(a, v, d, c, b) : R.bufferData(a, b, d) : R.bufferData(a, c ? v.subarray(c, c + b) : b, d);
}, emscripten_glBufferSubData:(a, b, c, d) => {
  2 <= T.version ? c && R.bufferSubData(a, b, v, d, c) : R.bufferSubData(a, b, v.subarray(d, d + c));
}, emscripten_glCheckFramebufferStatus:a => R.checkFramebufferStatus(a), emscripten_glClear:a => R.clear(a), emscripten_glClearColor:(a, b, c, d) => R.clearColor(a, b, c, d), emscripten_glClearStencil:a => R.clearStencil(a), emscripten_glClientWaitSync:(a, b, c, d) => R.clientWaitSync(Od[a], b, (c >>> 0) + 4294967296 * d), emscripten_glColorMask:(a, b, c, d) => {
  R.colorMask(!!a, !!b, !!c, !!d);
}, emscripten_glCompileShader:a => {
  R.compileShader(Ld[a]);
}, emscripten_glCompressedTexImage2D:(a, b, c, d, e, f, g, k) => {
  2 <= T.version ? R.ea || !g ? R.compressedTexImage2D(a, b, c, d, e, f, g, k) : R.compressedTexImage2D(a, b, c, d, e, f, v, k, g) : R.compressedTexImage2D(a, b, c, d, e, f, k ? v.subarray(k, k + g) : null);
}, emscripten_glCompressedTexSubImage2D:(a, b, c, d, e, f, g, k, m) => {
  2 <= T.version ? R.ea || !k ? R.compressedTexSubImage2D(a, b, c, d, e, f, g, k, m) : R.compressedTexSubImage2D(a, b, c, d, e, f, g, v, m, k) : R.compressedTexSubImage2D(a, b, c, d, e, f, g, m ? v.subarray(m, m + k) : null);
}, emscripten_glCopyTexSubImage2D:(a, b, c, d, e, f, g, k) => R.copyTexSubImage2D(a, b, c, d, e, f, g, k), emscripten_glCreateProgram:() => {
  var a = la(Q), b = R.createProgram();
  b.name = a;
  b.xa = b.va = b.wa = 0;
  b.Qa = 1;
  Q[a] = b;
  return a;
}, emscripten_glCreateShader:a => {
  var b = la(Ld);
  Ld[b] = R.createShader(a);
  return b;
}, emscripten_glCullFace:a => R.cullFace(a), emscripten_glDeleteBuffers:(a, b) => {
  for (var c = 0; c < a; c++) {
    var d = x[b + 4 * c >> 2], e = Hd[d];
    e && (R.deleteBuffer(e), e.name = 0, Hd[d] = null, d == R.Ia && (R.Ia = 0), d == R.ea && (R.ea = 0));
  }
}, emscripten_glDeleteFramebuffers:(a, b) => {
  for (var c = 0; c < a; ++c) {
    var d = x[b + 4 * c >> 2], e = Id[d];
    e && (R.deleteFramebuffer(e), e.name = 0, Id[d] = null);
  }
}, emscripten_glDeleteProgram:a => {
  if (a) {
    var b = Q[a];
    b ? (R.deleteProgram(b), b.name = 0, Q[a] = null) : S ||= 1281;
  }
}, emscripten_glDeleteRenderbuffers:(a, b) => {
  for (var c = 0; c < a; c++) {
    var d = x[b + 4 * c >> 2], e = Jd[d];
    e && (R.deleteRenderbuffer(e), e.name = 0, Jd[d] = null);
  }
}, emscripten_glDeleteSamplers:(a, b) => {
  for (var c = 0; c < a; c++) {
    var d = x[b + 4 * c >> 2], e = Nd[d];
    e && (R.deleteSampler(e), e.name = 0, Nd[d] = null);
  }
}, emscripten_glDeleteShader:a => {
  if (a) {
    var b = Ld[a];
    b ? (R.deleteShader(b), Ld[a] = null) : S ||= 1281;
  }
}, emscripten_glDeleteSync:a => {
  if (a) {
    var b = Od[a];
    b ? (R.deleteSync(b), b.name = 0, Od[a] = null) : S ||= 1281;
  }
}, emscripten_glDeleteTextures:(a, b) => {
  for (var c = 0; c < a; c++) {
    var d = x[b + 4 * c >> 2], e = Kd[d];
    e && (R.deleteTexture(e), e.name = 0, Kd[d] = null);
  }
}, emscripten_glDeleteVertexArrays:Wd, emscripten_glDeleteVertexArraysOES:Wd, emscripten_glDepthMask:a => {
  R.depthMask(!!a);
}, emscripten_glDisable:a => R.disable(a), emscripten_glDisableVertexAttribArray:a => {
  R.disableVertexAttribArray(a);
}, emscripten_glDrawArrays:(a, b, c) => {
  R.drawArrays(a, b, c);
}, emscripten_glDrawArraysInstanced:(a, b, c, d) => {
  R.drawArraysInstanced(a, b, c, d);
}, emscripten_glDrawArraysInstancedBaseInstanceWEBGL:(a, b, c, d, e) => {
  R.Ya.drawArraysInstancedBaseInstanceWEBGL(a, b, c, d, e);
}, emscripten_glDrawBuffers:(a, b) => {
  for (var c = Xd[a], d = 0; d < a; d++) {
    c[d] = x[b + 4 * d >> 2];
  }
  R.drawBuffers(c);
}, emscripten_glDrawElements:(a, b, c, d) => {
  R.drawElements(a, b, c, d);
}, emscripten_glDrawElementsInstanced:(a, b, c, d, e) => {
  R.drawElementsInstanced(a, b, c, d, e);
}, emscripten_glDrawElementsInstancedBaseVertexBaseInstanceWEBGL:(a, b, c, d, e, f, g) => {
  R.Ya.drawElementsInstancedBaseVertexBaseInstanceWEBGL(a, b, c, d, e, f, g);
}, emscripten_glDrawRangeElements:(a, b, c, d, e, f) => {
  R.drawElements(a, d, e, f);
}, emscripten_glEnable:a => R.enable(a), emscripten_glEnableVertexAttribArray:a => {
  R.enableVertexAttribArray(a);
}, emscripten_glFenceSync:(a, b) => (a = R.fenceSync(a, b)) ? (b = la(Od), a.name = b, Od[b] = a, b) : 0, emscripten_glFinish:() => R.finish(), emscripten_glFlush:() => R.flush(), emscripten_glFramebufferRenderbuffer:(a, b, c, d) => {
  R.framebufferRenderbuffer(a, b, c, Jd[d]);
}, emscripten_glFramebufferTexture2D:(a, b, c, d, e) => {
  R.framebufferTexture2D(a, b, c, Kd[d], e);
}, emscripten_glFrontFace:a => R.frontFace(a), emscripten_glGenBuffers:(a, b) => {
  Td(a, b, "createBuffer", Hd);
}, emscripten_glGenFramebuffers:(a, b) => {
  Td(a, b, "createFramebuffer", Id);
}, emscripten_glGenRenderbuffers:(a, b) => {
  Td(a, b, "createRenderbuffer", Jd);
}, emscripten_glGenSamplers:(a, b) => {
  Td(a, b, "createSampler", Nd);
}, emscripten_glGenTextures:(a, b) => {
  Td(a, b, "createTexture", Kd);
}, emscripten_glGenVertexArrays:Yd, emscripten_glGenVertexArraysOES:Yd, emscripten_glGenerateMipmap:a => R.generateMipmap(a), emscripten_glGetBufferParameteriv:(a, b, c) => {
  c ? x[c >> 2] = R.getBufferParameter(a, b) : S ||= 1281;
}, emscripten_glGetError:() => {
  var a = R.getError() || S;
  S = 0;
  return a;
}, emscripten_glGetFramebufferAttachmentParameteriv:(a, b, c, d) => {
  a = R.getFramebufferAttachmentParameter(a, b, c);
  if (a instanceof WebGLRenderbuffer || a instanceof WebGLTexture) {
    a = a.name | 0;
  }
  x[d >> 2] = a;
}, emscripten_glGetIntegerv:ae, emscripten_glGetProgramInfoLog:(a, b, c, d) => {
  a = R.getProgramInfoLog(Q[a]);
  null === a && (a = "(unknown error)");
  b = 0 < b && d ? kb(a, v, d, b) : 0;
  c && (x[c >> 2] = b);
}, emscripten_glGetProgramiv:(a, b, c) => {
  if (c) {
    if (a >= Gd) {
      S ||= 1281;
    } else {
      if (a = Q[a], 35716 == b) {
        a = R.getProgramInfoLog(a), null === a && (a = "(unknown error)"), x[c >> 2] = a.length + 1;
      } else if (35719 == b) {
        if (!a.xa) {
          for (b = 0; b < R.getProgramParameter(a, 35718); ++b) {
            a.xa = Math.max(a.xa, R.getActiveUniform(a, b).name.length + 1);
          }
        }
        x[c >> 2] = a.xa;
      } else if (35722 == b) {
        if (!a.va) {
          for (b = 0; b < R.getProgramParameter(a, 35721); ++b) {
            a.va = Math.max(a.va, R.getActiveAttrib(a, b).name.length + 1);
          }
        }
        x[c >> 2] = a.va;
      } else if (35381 == b) {
        if (!a.wa) {
          for (b = 0; b < R.getProgramParameter(a, 35382); ++b) {
            a.wa = Math.max(a.wa, R.getActiveUniformBlockName(a, b).length + 1);
          }
        }
        x[c >> 2] = a.wa;
      } else {
        x[c >> 2] = R.getProgramParameter(a, b);
      }
    }
  } else {
    S ||= 1281;
  }
}, emscripten_glGetRenderbufferParameteriv:(a, b, c) => {
  c ? x[c >> 2] = R.getRenderbufferParameter(a, b) : S ||= 1281;
}, emscripten_glGetShaderInfoLog:(a, b, c, d) => {
  a = R.getShaderInfoLog(Ld[a]);
  null === a && (a = "(unknown error)");
  b = 0 < b && d ? kb(a, v, d, b) : 0;
  c && (x[c >> 2] = b);
}, emscripten_glGetShaderPrecisionFormat:(a, b, c, d) => {
  a = R.getShaderPrecisionFormat(a, b);
  x[c >> 2] = a.rangeMin;
  x[c + 4 >> 2] = a.rangeMax;
  x[d >> 2] = a.precision;
}, emscripten_glGetShaderiv:(a, b, c) => {
  c ? 35716 == b ? (a = R.getShaderInfoLog(Ld[a]), null === a && (a = "(unknown error)"), x[c >> 2] = a ? a.length + 1 : 0) : 35720 == b ? (a = R.getShaderSource(Ld[a]), x[c >> 2] = a ? a.length + 1 : 0) : x[c >> 2] = R.getShaderParameter(Ld[a], b) : S ||= 1281;
}, emscripten_glGetString:a => {
  var b = Pd[a];
  if (!b) {
    switch(a) {
      case 7939:
        b = ce(Zd().join(" "));
        break;
      case 7936:
      case 7937:
      case 37445:
      case 37446:
        (b = R.getParameter(a)) || (S ||= 1280);
        b = b ? ce(b) : 0;
        break;
      case 7938:
        b = R.getParameter(7938);
        b = 2 <= T.version ? `OpenGL ES 3.0 (${b})` : `OpenGL ES 2.0 (${b})`;
        b = ce(b);
        break;
      case 35724:
        b = R.getParameter(35724);
        var c = b.match(/^WebGL GLSL ES ([0-9]\.[0-9][0-9]?)(?:$| .*)/);
        null !== c && (3 == c[1].length && (c[1] += "0"), b = `OpenGL ES GLSL ES ${c[1]} (${b})`);
        b = ce(b);
        break;
      default:
        S ||= 1280;
    }
    Pd[a] = b;
  }
  return b;
}, emscripten_glGetStringi:(a, b) => {
  if (2 > T.version) {
    return S ||= 1282, 0;
  }
  var c = Qd[a];
  if (c) {
    return 0 > b || b >= c.length ? (S ||= 1281, 0) : c[b];
  }
  switch(a) {
    case 7939:
      return c = Zd().map(ce), c = Qd[a] = c, 0 > b || b >= c.length ? (S ||= 1281, 0) : c[b];
    default:
      return S ||= 1280, 0;
  }
}, emscripten_glGetUniformLocation:(a, b) => {
  b = b ? D(v, b) : "";
  if (a = Q[a]) {
    var c = a, d = c.la, e = c.sb, f;
    if (!d) {
      for (c.la = d = {}, c.rb = {}, f = 0; f < R.getProgramParameter(c, 35718); ++f) {
        var g = R.getActiveUniform(c, f);
        var k = g.name;
        g = g.size;
        var m = de(k);
        m = 0 < m ? k.slice(0, m) : k;
        var p = c.Qa;
        c.Qa += g;
        e[m] = [g, p];
        for (k = 0; k < g; ++k) {
          d[p] = k, c.rb[p++] = m;
        }
      }
    }
    c = a.la;
    d = 0;
    e = b;
    f = de(b);
    0 < f && (d = parseInt(b.slice(f + 1)) >>> 0, e = b.slice(0, f));
    if ((e = a.sb[e]) && d < e[0] && (d += e[1], c[d] = c[d] || R.getUniformLocation(a, b))) {
      return d;
    }
  } else {
    S ||= 1281;
  }
  return -1;
}, emscripten_glInvalidateFramebuffer:(a, b, c) => {
  for (var d = Xd[b], e = 0; e < b; e++) {
    d[e] = x[c + 4 * e >> 2];
  }
  R.invalidateFramebuffer(a, d);
}, emscripten_glInvalidateSubFramebuffer:(a, b, c, d, e, f, g) => {
  for (var k = Xd[b], m = 0; m < b; m++) {
    k[m] = x[c + 4 * m >> 2];
  }
  R.invalidateSubFramebuffer(a, k, d, e, f, g);
}, emscripten_glIsSync:a => R.isSync(Od[a]), emscripten_glIsTexture:a => (a = Kd[a]) ? R.isTexture(a) : 0, emscripten_glLineWidth:a => R.lineWidth(a), emscripten_glLinkProgram:a => {
  a = Q[a];
  R.linkProgram(a);
  a.la = 0;
  a.sb = {};
}, emscripten_glMultiDrawArraysInstancedBaseInstanceWEBGL:(a, b, c, d, e, f) => {
  R.fb.multiDrawArraysInstancedBaseInstanceWEBGL(a, x, b >> 2, x, c >> 2, x, d >> 2, A, e >> 2, f);
}, emscripten_glMultiDrawElementsInstancedBaseVertexBaseInstanceWEBGL:(a, b, c, d, e, f, g, k) => {
  R.fb.multiDrawElementsInstancedBaseVertexBaseInstanceWEBGL(a, x, b >> 2, c, x, d >> 2, x, e >> 2, x, f >> 2, A, g >> 2, k);
}, emscripten_glPixelStorei:(a, b) => {
  3317 == a ? Rd = b : 3314 == a && (Sd = b);
  R.pixelStorei(a, b);
}, emscripten_glReadBuffer:a => R.readBuffer(a), emscripten_glReadPixels:(a, b, c, d, e, f, g) => {
  if (2 <= T.version) {
    if (R.Ia) {
      R.readPixels(a, b, c, d, e, f, g);
    } else {
      var k = ee(f);
      g >>>= 31 - Math.clz32(k.BYTES_PER_ELEMENT);
      R.readPixels(a, b, c, d, e, f, k, g);
    }
  } else {
    (k = fe(f, e, c, d, g)) ? R.readPixels(a, b, c, d, e, f, k) : S ||= 1280;
  }
}, emscripten_glRenderbufferStorage:(a, b, c, d) => R.renderbufferStorage(a, b, c, d), emscripten_glRenderbufferStorageMultisample:(a, b, c, d, e) => R.renderbufferStorageMultisample(a, b, c, d, e), emscripten_glSamplerParameteri:(a, b, c) => {
  R.samplerParameteri(Nd[a], b, c);
}, emscripten_glSamplerParameteriv:(a, b, c) => {
  R.samplerParameteri(Nd[a], b, x[c >> 2]);
}, emscripten_glScissor:(a, b, c, d) => R.scissor(a, b, c, d), emscripten_glShaderSource:(a, b, c, d) => {
  for (var e = "", f = 0; f < b; ++f) {
    var g = (g = A[c + 4 * f >> 2]) ? D(v, g, d ? A[d + 4 * f >> 2] : void 0) : "";
    e += g;
  }
  R.shaderSource(Ld[a], e);
}, emscripten_glStencilFunc:(a, b, c) => R.stencilFunc(a, b, c), emscripten_glStencilFuncSeparate:(a, b, c, d) => R.stencilFuncSeparate(a, b, c, d), emscripten_glStencilMask:a => R.stencilMask(a), emscripten_glStencilMaskSeparate:(a, b) => R.stencilMaskSeparate(a, b), emscripten_glStencilOp:(a, b, c) => R.stencilOp(a, b, c), emscripten_glStencilOpSeparate:(a, b, c, d) => R.stencilOpSeparate(a, b, c, d), emscripten_glTexImage2D:(a, b, c, d, e, f, g, k, m) => {
  if (2 <= T.version) {
    if (R.ea) {
      R.texImage2D(a, b, c, d, e, f, g, k, m);
      return;
    }
    if (m) {
      var p = ee(k);
      m >>>= 31 - Math.clz32(p.BYTES_PER_ELEMENT);
      R.texImage2D(a, b, c, d, e, f, g, k, p, m);
      return;
    }
  }
  p = m ? fe(k, g, d, e, m) : null;
  R.texImage2D(a, b, c, d, e, f, g, k, p);
}, emscripten_glTexParameterf:(a, b, c) => R.texParameterf(a, b, c), emscripten_glTexParameterfv:(a, b, c) => {
  R.texParameterf(a, b, B[c >> 2]);
}, emscripten_glTexParameteri:(a, b, c) => R.texParameteri(a, b, c), emscripten_glTexParameteriv:(a, b, c) => {
  R.texParameteri(a, b, x[c >> 2]);
}, emscripten_glTexStorage2D:(a, b, c, d, e) => R.texStorage2D(a, b, c, d, e), emscripten_glTexSubImage2D:(a, b, c, d, e, f, g, k, m) => {
  if (2 <= T.version) {
    if (R.ea) {
      R.texSubImage2D(a, b, c, d, e, f, g, k, m);
      return;
    }
    if (m) {
      var p = ee(k);
      R.texSubImage2D(a, b, c, d, e, f, g, k, p, m >>> 31 - Math.clz32(p.BYTES_PER_ELEMENT));
      return;
    }
  }
  m = m ? fe(k, g, e, f, m) : null;
  R.texSubImage2D(a, b, c, d, e, f, g, k, m);
}, emscripten_glUniform1f:(a, b) => {
  R.uniform1f(U(a), b);
}, emscripten_glUniform1fv:(a, b, c) => {
  if (2 <= T.version) {
    b && R.uniform1fv(U(a), B, c >> 2, b);
  } else {
    if (288 >= b) {
      for (var d = ge[b], e = 0; e < b; ++e) {
        d[e] = B[c + 4 * e >> 2];
      }
    } else {
      d = B.subarray(c >> 2, c + 4 * b >> 2);
    }
    R.uniform1fv(U(a), d);
  }
}, emscripten_glUniform1i:(a, b) => {
  R.uniform1i(U(a), b);
}, emscripten_glUniform1iv:(a, b, c) => {
  if (2 <= T.version) {
    b && R.uniform1iv(U(a), x, c >> 2, b);
  } else {
    if (288 >= b) {
      for (var d = he[b], e = 0; e < b; ++e) {
        d[e] = x[c + 4 * e >> 2];
      }
    } else {
      d = x.subarray(c >> 2, c + 4 * b >> 2);
    }
    R.uniform1iv(U(a), d);
  }
}, emscripten_glUniform2f:(a, b, c) => {
  R.uniform2f(U(a), b, c);
}, emscripten_glUniform2fv:(a, b, c) => {
  if (2 <= T.version) {
    b && R.uniform2fv(U(a), B, c >> 2, 2 * b);
  } else {
    if (144 >= b) {
      for (var d = ge[2 * b], e = 0; e < 2 * b; e += 2) {
        d[e] = B[c + 4 * e >> 2], d[e + 1] = B[c + (4 * e + 4) >> 2];
      }
    } else {
      d = B.subarray(c >> 2, c + 8 * b >> 2);
    }
    R.uniform2fv(U(a), d);
  }
}, emscripten_glUniform2i:(a, b, c) => {
  R.uniform2i(U(a), b, c);
}, emscripten_glUniform2iv:(a, b, c) => {
  if (2 <= T.version) {
    b && R.uniform2iv(U(a), x, c >> 2, 2 * b);
  } else {
    if (144 >= b) {
      for (var d = he[2 * b], e = 0; e < 2 * b; e += 2) {
        d[e] = x[c + 4 * e >> 2], d[e + 1] = x[c + (4 * e + 4) >> 2];
      }
    } else {
      d = x.subarray(c >> 2, c + 8 * b >> 2);
    }
    R.uniform2iv(U(a), d);
  }
}, emscripten_glUniform3f:(a, b, c, d) => {
  R.uniform3f(U(a), b, c, d);
}, emscripten_glUniform3fv:(a, b, c) => {
  if (2 <= T.version) {
    b && R.uniform3fv(U(a), B, c >> 2, 3 * b);
  } else {
    if (96 >= b) {
      for (var d = ge[3 * b], e = 0; e < 3 * b; e += 3) {
        d[e] = B[c + 4 * e >> 2], d[e + 1] = B[c + (4 * e + 4) >> 2], d[e + 2] = B[c + (4 * e + 8) >> 2];
      }
    } else {
      d = B.subarray(c >> 2, c + 12 * b >> 2);
    }
    R.uniform3fv(U(a), d);
  }
}, emscripten_glUniform3i:(a, b, c, d) => {
  R.uniform3i(U(a), b, c, d);
}, emscripten_glUniform3iv:(a, b, c) => {
  if (2 <= T.version) {
    b && R.uniform3iv(U(a), x, c >> 2, 3 * b);
  } else {
    if (96 >= b) {
      for (var d = he[3 * b], e = 0; e < 3 * b; e += 3) {
        d[e] = x[c + 4 * e >> 2], d[e + 1] = x[c + (4 * e + 4) >> 2], d[e + 2] = x[c + (4 * e + 8) >> 2];
      }
    } else {
      d = x.subarray(c >> 2, c + 12 * b >> 2);
    }
    R.uniform3iv(U(a), d);
  }
}, emscripten_glUniform4f:(a, b, c, d, e) => {
  R.uniform4f(U(a), b, c, d, e);
}, emscripten_glUniform4fv:(a, b, c) => {
  if (2 <= T.version) {
    b && R.uniform4fv(U(a), B, c >> 2, 4 * b);
  } else {
    if (72 >= b) {
      var d = ge[4 * b], e = B;
      c >>= 2;
      for (var f = 0; f < 4 * b; f += 4) {
        var g = c + f;
        d[f] = e[g];
        d[f + 1] = e[g + 1];
        d[f + 2] = e[g + 2];
        d[f + 3] = e[g + 3];
      }
    } else {
      d = B.subarray(c >> 2, c + 16 * b >> 2);
    }
    R.uniform4fv(U(a), d);
  }
}, emscripten_glUniform4i:(a, b, c, d, e) => {
  R.uniform4i(U(a), b, c, d, e);
}, emscripten_glUniform4iv:(a, b, c) => {
  if (2 <= T.version) {
    b && R.uniform4iv(U(a), x, c >> 2, 4 * b);
  } else {
    if (72 >= b) {
      for (var d = he[4 * b], e = 0; e < 4 * b; e += 4) {
        d[e] = x[c + 4 * e >> 2], d[e + 1] = x[c + (4 * e + 4) >> 2], d[e + 2] = x[c + (4 * e + 8) >> 2], d[e + 3] = x[c + (4 * e + 12) >> 2];
      }
    } else {
      d = x.subarray(c >> 2, c + 16 * b >> 2);
    }
    R.uniform4iv(U(a), d);
  }
}, emscripten_glUniformMatrix2fv:(a, b, c, d) => {
  if (2 <= T.version) {
    b && R.uniformMatrix2fv(U(a), !!c, B, d >> 2, 4 * b);
  } else {
    if (72 >= b) {
      for (var e = ge[4 * b], f = 0; f < 4 * b; f += 4) {
        e[f] = B[d + 4 * f >> 2], e[f + 1] = B[d + (4 * f + 4) >> 2], e[f + 2] = B[d + (4 * f + 8) >> 2], e[f + 3] = B[d + (4 * f + 12) >> 2];
      }
    } else {
      e = B.subarray(d >> 2, d + 16 * b >> 2);
    }
    R.uniformMatrix2fv(U(a), !!c, e);
  }
}, emscripten_glUniformMatrix3fv:(a, b, c, d) => {
  if (2 <= T.version) {
    b && R.uniformMatrix3fv(U(a), !!c, B, d >> 2, 9 * b);
  } else {
    if (32 >= b) {
      for (var e = ge[9 * b], f = 0; f < 9 * b; f += 9) {
        e[f] = B[d + 4 * f >> 2], e[f + 1] = B[d + (4 * f + 4) >> 2], e[f + 2] = B[d + (4 * f + 8) >> 2], e[f + 3] = B[d + (4 * f + 12) >> 2], e[f + 4] = B[d + (4 * f + 16) >> 2], e[f + 5] = B[d + (4 * f + 20) >> 2], e[f + 6] = B[d + (4 * f + 24) >> 2], e[f + 7] = B[d + (4 * f + 28) >> 2], e[f + 8] = B[d + (4 * f + 32) >> 2];
      }
    } else {
      e = B.subarray(d >> 2, d + 36 * b >> 2);
    }
    R.uniformMatrix3fv(U(a), !!c, e);
  }
}, emscripten_glUniformMatrix4fv:(a, b, c, d) => {
  if (2 <= T.version) {
    b && R.uniformMatrix4fv(U(a), !!c, B, d >> 2, 16 * b);
  } else {
    if (18 >= b) {
      var e = ge[16 * b], f = B;
      d >>= 2;
      for (var g = 0; g < 16 * b; g += 16) {
        var k = d + g;
        e[g] = f[k];
        e[g + 1] = f[k + 1];
        e[g + 2] = f[k + 2];
        e[g + 3] = f[k + 3];
        e[g + 4] = f[k + 4];
        e[g + 5] = f[k + 5];
        e[g + 6] = f[k + 6];
        e[g + 7] = f[k + 7];
        e[g + 8] = f[k + 8];
        e[g + 9] = f[k + 9];
        e[g + 10] = f[k + 10];
        e[g + 11] = f[k + 11];
        e[g + 12] = f[k + 12];
        e[g + 13] = f[k + 13];
        e[g + 14] = f[k + 14];
        e[g + 15] = f[k + 15];
      }
    } else {
      e = B.subarray(d >> 2, d + 64 * b >> 2);
    }
    R.uniformMatrix4fv(U(a), !!c, e);
  }
}, emscripten_glUseProgram:a => {
  a = Q[a];
  R.useProgram(a);
  R.Db = a;
}, emscripten_glVertexAttrib1f:(a, b) => R.vertexAttrib1f(a, b), emscripten_glVertexAttrib2fv:(a, b) => {
  R.vertexAttrib2f(a, B[b >> 2], B[b + 4 >> 2]);
}, emscripten_glVertexAttrib3fv:(a, b) => {
  R.vertexAttrib3f(a, B[b >> 2], B[b + 4 >> 2], B[b + 8 >> 2]);
}, emscripten_glVertexAttrib4fv:(a, b) => {
  R.vertexAttrib4f(a, B[b >> 2], B[b + 4 >> 2], B[b + 8 >> 2], B[b + 12 >> 2]);
}, emscripten_glVertexAttribDivisor:(a, b) => {
  R.vertexAttribDivisor(a, b);
}, emscripten_glVertexAttribIPointer:(a, b, c, d, e) => {
  R.vertexAttribIPointer(a, b, c, d, e);
}, emscripten_glVertexAttribPointer:(a, b, c, d, e, f) => {
  R.vertexAttribPointer(a, b, c, !!d, e, f);
}, emscripten_glViewport:(a, b, c, d) => R.viewport(a, b, c, d), emscripten_glWaitSync:(a, b, c, d) => {
  R.waitSync(Od[a], b, (c >>> 0) + 4294967296 * d);
}, emscripten_resize_heap:a => {
  var b = v.length;
  a >>>= 0;
  if (2147483648 < a) {
    return !1;
  }
  for (var c = 1; 4 >= c; c *= 2) {
    var d = b * (1 + 0.2 / c);
    d = Math.min(d, a + 100663296);
    var e = Math;
    d = Math.max(a, d);
    a: {
      e = (e.min.call(e, 2147483648, d + (65536 - d % 65536) % 65536) - ya.buffer.byteLength + 65535) / 65536;
      try {
        ya.grow(e);
        Da();
        var f = 1;
        break a;
      } catch (g) {
      }
      f = void 0;
    }
    if (f) {
      return !0;
    }
  }
  return !1;
}, emscripten_webgl_get_current_context:() => T ? T.handle : 0, emscripten_webgl_make_context_current:a => oa(a) ? 0 : -5, environ_get:(a, b) => {
  var c = 0;
  ke().forEach((d, e) => {
    var f = b + c;
    e = A[a + 4 * e >> 2] = f;
    for (f = 0; f < d.length; ++f) {
      n[e++] = d.charCodeAt(f);
    }
    n[e] = 0;
    c += d.length + 1;
  });
  return 0;
}, environ_sizes_get:(a, b) => {
  var c = ke();
  A[a >> 2] = c.length;
  var d = 0;
  c.forEach(e => d += e.length + 1);
  A[b >> 2] = d;
  return 0;
}, fd_close:function(a) {
  try {
    var b = Pb(a);
    if (null === b.U) {
      throw new F(8);
    }
    b.Ka && (b.Ka = null);
    try {
      b.m.close && b.m.close(b);
    } catch (c) {
      throw c;
    } finally {
      Cb[b.U] = null;
    }
    b.U = null;
    return 0;
  } catch (c) {
    if ("undefined" == typeof cc || "ErrnoError" !== c.name) {
      throw c;
    }
    return c.Y;
  }
}, fd_read:function(a, b, c, d) {
  try {
    a: {
      var e = Pb(a);
      a = b;
      for (var f, g = b = 0; g < c; g++) {
        var k = A[a >> 2], m = A[a + 4 >> 2];
        a += 8;
        var p = e, r = f, w = n;
        if (0 > m || 0 > r) {
          throw new F(28);
        }
        if (null === p.U) {
          throw new F(8);
        }
        if (1 === (p.flags & 2097155)) {
          throw new F(8);
        }
        if (16384 === (p.node.mode & 61440)) {
          throw new F(31);
        }
        if (!p.m.read) {
          throw new F(28);
        }
        var y = "undefined" != typeof r;
        if (!y) {
          r = p.position;
        } else if (!p.seekable) {
          throw new F(70);
        }
        var q = p.m.read(p, w, k, m, r);
        y || (p.position += q);
        var t = q;
        if (0 > t) {
          var u = -1;
          break a;
        }
        b += t;
        if (t < m) {
          break;
        }
        "undefined" != typeof f && (f += t);
      }
      u = b;
    }
    A[d >> 2] = u;
    return 0;
  } catch (z) {
    if ("undefined" == typeof cc || "ErrnoError" !== z.name) {
      throw z;
    }
    return z.Y;
  }
}, fd_seek:function(a, b, c, d, e) {
  b = c + 2097152 >>> 0 < 4194305 - !!b ? (b >>> 0) + 4294967296 * c : NaN;
  try {
    if (isNaN(b)) {
      return 61;
    }
    var f = Pb(a);
    Zb(f, b, d);
    Ta = [f.position >>> 0, (Sa = f.position, 1.0 <= +Math.abs(Sa) ? 0.0 < Sa ? +Math.floor(Sa / 4294967296.0) >>> 0 : ~~+Math.ceil((Sa - +(~~Sa >>> 0)) / 4294967296.0) >>> 0 : 0)];
    x[e >> 2] = Ta[0];
    x[e + 4 >> 2] = Ta[1];
    f.Ka && 0 === b && 0 === d && (f.Ka = null);
    return 0;
  } catch (g) {
    if ("undefined" == typeof cc || "ErrnoError" !== g.name) {
      throw g;
    }
    return g.Y;
  }
}, fd_write:function(a, b, c, d) {
  try {
    a: {
      var e = Pb(a);
      a = b;
      for (var f, g = b = 0; g < c; g++) {
        var k = A[a >> 2], m = A[a + 4 >> 2];
        a += 8;
        var p = e, r = k, w = m, y = f, q = n;
        if (0 > w || 0 > y) {
          throw new F(28);
        }
        if (null === p.U) {
          throw new F(8);
        }
        if (0 === (p.flags & 2097155)) {
          throw new F(8);
        }
        if (16384 === (p.node.mode & 61440)) {
          throw new F(31);
        }
        if (!p.m.write) {
          throw new F(28);
        }
        p.seekable && p.flags & 1024 && Zb(p, 0, 2);
        var t = "undefined" != typeof y;
        if (!t) {
          y = p.position;
        } else if (!p.seekable) {
          throw new F(70);
        }
        var u = p.m.write(p, q, r, w, y, void 0);
        t || (p.position += u);
        var z = u;
        if (0 > z) {
          var C = -1;
          break a;
        }
        b += z;
        "undefined" != typeof f && (f += z);
      }
      C = b;
    }
    A[d >> 2] = C;
    return 0;
  } catch (E) {
    if ("undefined" == typeof cc || "ErrnoError" !== E.name) {
      throw E;
    }
    return E.Y;
  }
}, glBindFramebuffer:Ud, glGetIntegerv:ae, invoke_ii:te, invoke_iii:ue, invoke_iiii:ve, invoke_iiiii:we, invoke_iiiiii:xe, invoke_iiiiiii:ye, invoke_iiiiiiiiii:ze, invoke_v:Ae, invoke_vi:Be, invoke_vii:Ce, invoke_viii:De, invoke_viiii:Ee, invoke_viiiiii:Fe, invoke_viiiiiii:Ge, invoke_viiiiiiii:He, strftime_l:(a, b, c, d) => oe(a, b, c, d)}, W = function() {
  function a(c) {
    W = c.exports;
    ya = W.memory;
    Da();
    Yc = W.__indirect_function_table;
    Fa.unshift(W.__wasm_call_ctors);
    Ia--;
    l.monitorRunDependencies?.(Ia);
    0 == Ia && (null !== Ja && (clearInterval(Ja), Ja = null), Ka && (c = Ka, Ka = null, c()));
    return W;
  }
  var b = {env:Ie, wasi_snapshot_preview1:Ie,};
  Ia++;
  l.monitorRunDependencies?.(Ia);
  if (l.instantiateWasm) {
    try {
      return l.instantiateWasm(b, a);
    } catch (c) {
      wa(`Module.instantiateWasm callback failed with error: ${c}`), ba(c);
    }
  }
  Na ||= Ma("webgl_advanced.wasm") ? "webgl_advanced.wasm" : l.locateFile ? l.locateFile("webgl_advanced.wasm", ra) : ra + "webgl_advanced.wasm";
  Ra(b, function(c) {
    a(c.instance);
  }).catch(ba);
  return {};
}(), sc = a => (sc = W.free)(a), be = a => (be = W.malloc)(a), rc = a => (rc = W.__getTypeName)(a), Ua = l._ma_device__on_notification_unlocked = a => (Ua = l._ma_device__on_notification_unlocked = W.ma_device__on_notification_unlocked)(a);
l._ma_malloc_emscripten = (a, b) => (l._ma_malloc_emscripten = W.ma_malloc_emscripten)(a, b);
l._ma_free_emscripten = (a, b) => (l._ma_free_emscripten = W.ma_free_emscripten)(a, b);
var Va = l._ma_device_process_pcm_frames_capture__webaudio = (a, b, c) => (Va = l._ma_device_process_pcm_frames_capture__webaudio = W.ma_device_process_pcm_frames_capture__webaudio)(a, b, c), Wa = l._ma_device_process_pcm_frames_playback__webaudio = (a, b, c) => (Wa = l._ma_device_process_pcm_frames_playback__webaudio = W.ma_device_process_pcm_frames_playback__webaudio)(a, b, c), xb = (a, b) => (xb = W.emscripten_builtin_memalign)(a, b), X = (a, b) => (X = W.setThrew)(a, b), Y = a => (Y = W._emscripten_stack_restore)(a), 
Z = () => (Z = W.emscripten_stack_get_current)();
l.dynCall_iiij = (a, b, c, d, e) => (l.dynCall_iiij = W.dynCall_iiij)(a, b, c, d, e);
l.dynCall_iiiij = (a, b, c, d, e, f) => (l.dynCall_iiiij = W.dynCall_iiiij)(a, b, c, d, e, f);
l.dynCall_viij = (a, b, c, d, e) => (l.dynCall_viij = W.dynCall_viij)(a, b, c, d, e);
l.dynCall_viiij = (a, b, c, d, e, f) => (l.dynCall_viiij = W.dynCall_viiij)(a, b, c, d, e, f);
l.dynCall_iiji = (a, b, c, d, e) => (l.dynCall_iiji = W.dynCall_iiji)(a, b, c, d, e);
l.dynCall_jiji = (a, b, c, d, e) => (l.dynCall_jiji = W.dynCall_jiji)(a, b, c, d, e);
l.dynCall_iiiji = (a, b, c, d, e, f) => (l.dynCall_iiiji = W.dynCall_iiiji)(a, b, c, d, e, f);
l.dynCall_iij = (a, b, c, d) => (l.dynCall_iij = W.dynCall_iij)(a, b, c, d);
l.dynCall_jii = (a, b, c) => (l.dynCall_jii = W.dynCall_jii)(a, b, c);
l.dynCall_viiiiij = (a, b, c, d, e, f, g, k) => (l.dynCall_viiiiij = W.dynCall_viiiiij)(a, b, c, d, e, f, g, k);
l.dynCall_viji = (a, b, c, d, e) => (l.dynCall_viji = W.dynCall_viji)(a, b, c, d, e);
l.dynCall_ji = (a, b) => (l.dynCall_ji = W.dynCall_ji)(a, b);
l.dynCall_vij = (a, b, c, d) => (l.dynCall_vij = W.dynCall_vij)(a, b, c, d);
l.dynCall_viijii = (a, b, c, d, e, f, g) => (l.dynCall_viijii = W.dynCall_viijii)(a, b, c, d, e, f, g);
l.dynCall_iiiiij = (a, b, c, d, e, f, g) => (l.dynCall_iiiiij = W.dynCall_iiiiij)(a, b, c, d, e, f, g);
l.dynCall_iiiiijj = (a, b, c, d, e, f, g, k, m) => (l.dynCall_iiiiijj = W.dynCall_iiiiijj)(a, b, c, d, e, f, g, k, m);
l.dynCall_iiiiiijj = (a, b, c, d, e, f, g, k, m, p) => (l.dynCall_iiiiiijj = W.dynCall_iiiiiijj)(a, b, c, d, e, f, g, k, m, p);
function te(a, b) {
  var c = Z();
  try {
    return K(a)(b);
  } catch (d) {
    Y(c);
    if (d !== d + 0) {
      throw d;
    }
    X(1, 0);
  }
}
function Ce(a, b, c) {
  var d = Z();
  try {
    K(a)(b, c);
  } catch (e) {
    Y(d);
    if (e !== e + 0) {
      throw e;
    }
    X(1, 0);
  }
}
function Be(a, b) {
  var c = Z();
  try {
    K(a)(b);
  } catch (d) {
    Y(c);
    if (d !== d + 0) {
      throw d;
    }
    X(1, 0);
  }
}
function ve(a, b, c, d) {
  var e = Z();
  try {
    return K(a)(b, c, d);
  } catch (f) {
    Y(e);
    if (f !== f + 0) {
      throw f;
    }
    X(1, 0);
  }
}
function De(a, b, c, d) {
  var e = Z();
  try {
    K(a)(b, c, d);
  } catch (f) {
    Y(e);
    if (f !== f + 0) {
      throw f;
    }
    X(1, 0);
  }
}
function Ee(a, b, c, d, e) {
  var f = Z();
  try {
    K(a)(b, c, d, e);
  } catch (g) {
    Y(f);
    if (g !== g + 0) {
      throw g;
    }
    X(1, 0);
  }
}
function Ae(a) {
  var b = Z();
  try {
    K(a)();
  } catch (c) {
    Y(b);
    if (c !== c + 0) {
      throw c;
    }
    X(1, 0);
  }
}
function ye(a, b, c, d, e, f, g) {
  var k = Z();
  try {
    return K(a)(b, c, d, e, f, g);
  } catch (m) {
    Y(k);
    if (m !== m + 0) {
      throw m;
    }
    X(1, 0);
  }
}
function ue(a, b, c) {
  var d = Z();
  try {
    return K(a)(b, c);
  } catch (e) {
    Y(d);
    if (e !== e + 0) {
      throw e;
    }
    X(1, 0);
  }
}
function Ge(a, b, c, d, e, f, g, k) {
  var m = Z();
  try {
    K(a)(b, c, d, e, f, g, k);
  } catch (p) {
    Y(m);
    if (p !== p + 0) {
      throw p;
    }
    X(1, 0);
  }
}
function ze(a, b, c, d, e, f, g, k, m, p) {
  var r = Z();
  try {
    return K(a)(b, c, d, e, f, g, k, m, p);
  } catch (w) {
    Y(r);
    if (w !== w + 0) {
      throw w;
    }
    X(1, 0);
  }
}
function we(a, b, c, d, e) {
  var f = Z();
  try {
    return K(a)(b, c, d, e);
  } catch (g) {
    Y(f);
    if (g !== g + 0) {
      throw g;
    }
    X(1, 0);
  }
}
function He(a, b, c, d, e, f, g, k, m) {
  var p = Z();
  try {
    K(a)(b, c, d, e, f, g, k, m);
  } catch (r) {
    Y(p);
    if (r !== r + 0) {
      throw r;
    }
    X(1, 0);
  }
}
function xe(a, b, c, d, e, f) {
  var g = Z();
  try {
    return K(a)(b, c, d, e, f);
  } catch (k) {
    Y(g);
    if (k !== k + 0) {
      throw k;
    }
    X(1, 0);
  }
}
function Fe(a, b, c, d, e, f, g) {
  var k = Z();
  try {
    K(a)(b, c, d, e, f, g);
  } catch (m) {
    Y(k);
    if (m !== m + 0) {
      throw m;
    }
    X(1, 0);
  }
}
var Je;
Ka = function Ke() {
  Je || Le();
  Je || (Ka = Ke);
};
function Le() {
  function a() {
    if (!Je && (Je = !0, l.calledRun = !0, !za)) {
      l.noFSInit || $b || ($b = !0, l.stdin = l.stdin, l.stdout = l.stdout, l.stderr = l.stderr, l.stdin ? ac("stdin", l.stdin) : Wb("/dev/tty", "/dev/stdin"), l.stdout ? ac("stdout", null, l.stdout) : Wb("/dev/tty", "/dev/stdout"), l.stderr ? ac("stderr", null, l.stderr) : Wb("/dev/tty1", "/dev/stderr"), Xb("/dev/stdin", 0), Xb("/dev/stdout", 1), Xb("/dev/stderr", 1));
      Fb = !1;
      Ya(Fa);
      aa(l);
      if (l.onRuntimeInitialized) {
        l.onRuntimeInitialized();
      }
      if (l.postRun) {
        for ("function" == typeof l.postRun && (l.postRun = [l.postRun]); l.postRun.length;) {
          var b = l.postRun.shift();
          Ga.unshift(b);
        }
      }
      Ya(Ga);
    }
  }
  if (!(0 < Ia)) {
    if (l.preRun) {
      for ("function" == typeof l.preRun && (l.preRun = [l.preRun]); l.preRun.length;) {
        Ha();
      }
    }
    Ya(Ea);
    0 < Ia || (l.setStatus ? (l.setStatus("Running..."), setTimeout(function() {
      setTimeout(function() {
        l.setStatus("");
      }, 1);
      a();
    }, 1)) : a());
  }
}
if (l.preInit) {
  for ("function" == typeof l.preInit && (l.preInit = [l.preInit]); 0 < l.preInit.length;) {
    l.preInit.pop()();
  }
}
Le();
moduleRtn = ca;



  return moduleRtn;
}
);
})();
export default Rive;
